import appConfig from '../../../config/app_config';

const NL = {
  EMAIL: 'Email',
  CONFIRM_EMAIL: 'Bevestig Email',
  LOG_OUT: 'Log uit',
  CATEGORIES_NONE: 'Geen categorieen beschikbaar',

  NO_ACCOUNT_ID:
    'Geen account ID aanwezig in de URL of de account is onbekend voor het gekozen account',
  NO_PARTNER_ID:
    'Het partner id is onjuist of niet aanwezig in de URL. Voer alstublieft een juiste partner id toe en probeer het nogmaals.',
  ACCOUNT_NAME: 'Account naam',
  ACCOUNT_DESCRIPTION: 'Account omschrijving',

  PREVIOUS: 'Vorige',
  CONTINUE: 'Verder',
  NEXT: 'Volgende',
  CANCEL: 'Annuleren',
  CANCEL_TOOLTIP: 'Annuleren',
  VISITOR: 'Bezoeker',
  PIN: 'Pin',
  ERROR_LOGIN: 'Error, foutieve data',
  ERROR: 'Error',
  MANAGER: 'Manager',
  LOGIN: 'Inloggen',
  CONFIRM_REGISTER: 'Registratie bevestigd',
  USERNAME: 'Gebruikersnaam',
  PASSWORD: 'Wachtwoord',
  MY_VISIT: 'Mijn bezoek',
  EVENTS: 'Evenementen',
  SETTINGS: 'Instellingen',
  SETTINGS_SAVE_OK: 'Instellingen succesvol opgeslagen',
  SETTINGS_SAVE_KO: 'Error, instellingen zijn niet opgeslagen',
  USER_PASSPORT: 'Paspoort',
  OPTIONS: 'Mogelijkheden',
  CHOOSE_YOUR_PRODUCTS: 'Kies uw producten',

  SEND_VIP_CODE: 'Verzend VIP code',
  SEND_USERGROUP_CODE: 'verzend code',
  COMM_MGR_05:
    'Er zijn geen gebruikers gevonden die aan de ingevoerde criteria voldoen!',
  DEFINE_AREA: 'Selecteer gebied',

  LOGIN_TEXT: 'Al een account? ',
  REGISTER_TEXT: 'Account aanmaken',
  ACTIVATION_CODE_REQUIRED: 'Activatie code is verplicht',
  ACTIVATION_CODE_TITLE: 'Activatiecode: ',
  ACTIVATION_CODE_TEXT:
    'Voer de activatiecode in die u per e-mail ontvangen heeft na het aanmaken van uw account. ',
  ACTIVATION_CODE_INPUT: 'Voer uw activatiecode in ',
  ALERT:
    'De app is nog niet beschikbaar. U ontvangt een e-mail zodra de app te downloaden is in de App Store.',

  TITLE: 'Titel',
  TEXT: 'Tekst',
  DESTINATION: 'Locatie',
  ACCOUNT_PREFERENCES_SAVED_CORRECTLY:
    'Account instellingen zijn succesvol opgeslagen!',
  PARTNER_PREFERENCES_SAVED_CORRECTLY:
    'Partner instellingen zijn succesvol opgeslagen!',
  ACCOUNT_ALREADY_ACTIVATED: 'Jouw account is reeds al geactiveerd!',
  LOCATION_CREATION_OK: 'Locatie succesvol aangemaakt',
  LOCATION_EDITING_OK: 'Locatie succesvol aangepast',
  ACCOUNT_SAVED_OK: 'Account is succesvol opgeslagen',
  USERGROUP_INFO_SAVED_OK: 'gebruikers-groep info succesvol opgeslagen',
  USERGROUP: 'Gebruikers groep',
  DELETE_USERGROUP_TITLE:
    'weet je zeker dat je de gebruikers-groep wilt verwijderen?',
  ACCOUNT_MNG: 'Account Management',
  CREATE: 'Aanmaken',
  SEND: 'Versturen',
  SAVE: 'Opslaan',
  SAVE_TOOLTIP: 'Opslaan',

  // Context menu entries
  CM_EVENTS: 'Evenementen',
  CM_SETTINGS: 'Instellingen',
  CM_DASHBOARD: 'Dashboard',
  CM_REMOVE: 'Verwijderen',
  CM_LOC_MNG: 'Locatie aanmaken',
  CM_ENV_MNG: 'Omgevingsmanagement',
  CM_INC_MNG: 'Incident melden',

  ONCE_ONLY_NOTIFICATION: 'Eenmalige notificatie',
  CREATE_NEW_NOTIFICATION: 'Nieuwe notificatie aanmaken',
  LOCATION_NOTIFICATION: 'Locatie notificatie',
  ALL_NOTIFICATION: 'Alle notificaties',
  EDIT_NOTIFICATION: 'Notificatie aanpassen',

  // QR-code scanner
  QR_CODE: 'QR-code scanner',
  ENTER_AMOUNT: 'Voer het bedrag in',
  SCAN_CODE: 'Scan de QR-code van de klant',
  ERROR1: 'U heeft nog niks ingevuld!',
  LAST_RESULT: 'Laatste resultaat',

  // Event dashboard
  EVENT_TITLE: 'Evenementen dashboard',

  // Growthvitamine / Groeivitamine / Growth vitamine / Groei vitamine CARDS
  DISCOUNT_ORDER: 'korting op uw hele bestelling',
  DISCOUNT_PRODUCT: 'korting op product',
  AVAILABLE_UNTIL: 'Beschikbaar tot',
  AWARD_VITAMIN: 'Speciale aanbieding',
  GROWTH_VITAMIN_EXPIRE_TEXT: 'Aanbieding verloopt om %s',
  GROWTH_VITAMIN_MIN_VALUE_TEXT: 'Geldig vanaf een orderwaarde van € %f',

  // Homepage
  USER_LOGGED_OUT: 'Succesvol uitgelogd',
  NO_CONTINUE_USING_WEBSITE: 'Nee, ik wil gebruik maken van de website',
  VIEW_ACTIVITIES: 'Bekijk',
  SEARCH_ACTIVITY: 'Zoek een activiteit',
  SEARCH_PRODUCTS: 'Zoek een product',
  ACTIVITIES_DESC:
    'Blader door de thema’s en vind activiteiten die bij jou passen ',
  ACTIVITIES_FOR_HIGHLIGHT: 'Activiteiten voor highlight ',
  ACTIVITIES_FOR_LOCATION: 'Activiteiten voor locatie ',
  CLOSE_ACTIVITIES: 'Sluit dit venster',
  GET_ACCOUNT_APP: 'Download de accountName app om te kunnen bieden',
  ACCOUNT_APP_TEXT:
    'Download de accountName app en laat u inspireren over alles wat u kunt zien en doen. De accountName-app biedt u veel voordelen voor uw bezoek aan accountName. ' +
    'Vind en boek eenvoudig uw favoriete activiteiten in slechts enkele drukken op het scherm.',
  ACCOUNT_APP_TEXT2:
    'De accountName app is alles wat u nodig heeft om het meeste uit uw bezoek aan accountName te halen.',
  WHATS_ON: 'Wat is er te doen',
  WHATS_ON_DESC: 'Wat is er de komende tijd te doen',
  FILTER_RESULTS: 'Verfijn resultaten',
  TODAY: 'Vandaag',
  NEXT_7_DAYS: 'Komende 7 dagen',
  NEXT_30_DAYS: 'Komende 30 dagen',
  NEXT_3_MONTHS: 'Volgende 3 maanden',
  SELECT_SPEC_DAYS: 'Selecteer specifieke dagen',
  WHAT_IS_WHERE: 'Wat is waar',
  WHAT_IS_WHERE_DESC: 'Wat is waar ',
  ACT_FOR_HIGHLIGHT: 'activiteiten',
  ACTIVITIES: 'Afspraken',
  ACTIVITIES_HOMEPAGE: 'Activiteiten',
  ACTIVITIES_TITLE: 'Bekijk onze activiteiten',
  GET_PERS_SUG:
    'Ontvang gepersonaliseerde suggesties door categorieën te selecteren met de knoppen aan de linkerkant. ',
  USER_WELCOME: 'Welkom terug,  ',
  PASS_MAX_FUN: 'Maak jouw paspoort aan',
  PERS_PASS: 'Jouw paspoort',
  CREATE_PASS_DESC_1:
    'Maak een persoonlijk paspoort aan en haal het maximale uit jouw bezoek aan',
  CREATE_PASS_DESC_2:
    'Het paspoort geeft toegang tot exclusieve activiteiten en kortingen. Personaliseer je bezoek op basis van jouw wensen en interesses. Het paspoort zorgt gegarandeerd voor meer plezier tijdens jouw verblijf ',
  CREATE_PASS_NOW: 'Maak nu je persoonlijke paspoort aan! ',
  CREATE_PASS: 'Paspoort aanmaken',
  PASS_DESC_1:
    'Ga verder met het plannen van jouw bezoek, of creëer een nieuwe trip naar ',
  PASS_DESC_2:
    'Bekijk jouw opgeslagen favorieten, persoonlijke suggesties en interesses in je paspoort.',
  GO_TO_PASS: 'Naar account',
  DISCOUNT: 'Korting',
  ITEM_NUMBER: 'Artikel nummer',

  // User passport
  USER_WANT_LOGOUT: 'Ja, ik wil uitloggen',
  USER_PASSPORT: 'Jouw account',
  USER_PASSPORT_DESC:
    'Creëer jouw persoonlijke paspoort om gepersonaliseerde suggesties te ontvangen, rewards te verdienen en jouw favorietenlijst te bekijken. ',
  USER_INTERRESTS: 'Jouw interesses',
  USER_INTERRESTS_DESC:
    'Geef aan in welke activiteiten jij geïnteresseerd bent, zodat we activiteiten kunnen aanbieden die bij je passen. ',
  YOUR_USER_REWARD_LVL: 'Jouw huidge reward level',
  USER_REWARD_LVL: 'Reward level',
  USER_CURRENT_LEVEL: 'Huidig level',
  USER_REWARD_LVL_DESC:
    'Verdien punten door activiteiten te doen. Behaal genoeg punten om het volgende reward level te bereiken en unlock speciale activiteiten en kortingen. ',
  USER_FAVORITES: 'Jouw favorieten',
  USER_EARNED_POINTS: 'Behaalde punten',
  USER_POINTS_TO_NEXT_LEVEL: 'Punten voor het volgende level',
  USER_FAVORITES_DESC:
    'Activiteiten die je aan je favorietenlijst hebt toegevoegd. ',
  USER_INTERESTS: 'Mijn interesses',
  USER_REWARD_POINTS: 'Punten',
  DEL_FAV: 'Favoriet verwijderen',
  SURE_DELETE_ACTIVITY: 'Weet je zeker dat je activiteit ',
  SURE_DELETE_FAV: ' van je favorieten lijst wilt verwijderen ?',
  USER_DETAILS: 'Persoonlijke gegevens',
  USER_LOCATION_NOT_FOUND: 'Adres niet gevonden',
  USER_LOCATION_NOT_FOUND_DESC: 'Het adres is niet gevonden',
  USER_LOCATION_NOT_FOUND_DESC2:
    'Er is iets mis gegaan bij het opslaan van je gegevens, probeert u het later nogmaals',
  USER_DETAILS_NOT_SAVED: 'Gebruiker details zijn niet opgeslagen',
  USER_DETAILS_SAVED: 'De gebruiker details zijn opgeslagen',
  GETTING_USER_INTERESTS: 'Ophalen gebruiker interesses',
  USER_PICTURE_UPLOAD: 'Voeg jouw foto toe om je account persoonlijk te maken',
  USER_QR_CODE:
    'Dit is jouw persoonlijke QR code, deze kun je laten scannen om zegels te ontvangen die met een vol zegel boekje voor korting zorgen.',
  FILTER_ACTIVITIES: 'Filter activiteiten',

  // Capacity Info page
  CAPACITY_INFO: 'Capaciteit info',
  CAP_CAL_FOR: 'Capaciteit kalender voor',
  CAP_SEL_EVENT:
    'Selecteer alstublieft eerst een event om de kalender capaciteit data op te halen.',
  CAP_EVENT_CAP: 'Event capaciteit: ',
  CAP_FREE_EVENT_CAP: 'Vrije event capaciteit: ',
  CAP_FREE_BATCH_CAP: 'Vrije batch capaciteit: ',
  CAP_BOOKED_BATCH_CAP: 'Geboekte batch capaciteit: ',
  CAP_CUR_OCCUPANCY: 'huidige bezetting: ',
  CAP_TOTAL_EVENT_CAP: 'Totale event capaciteit: ',
  CAP_BATCH_TIME: 'Batch tijd: ',
  CAP_TOTAL_BATCH_CAP: 'Totale batch capaciteit: ',

  // Dialog
  NEW_QUADRANT: 'Maak een nieuwe quadrant aan',
  TYPE_QUADRANT: 'Type quadrant',
  TYPE_OBJECT: 'Object',

  // Map
  MAP_TITLE: 'Map',
  ROUTE_MAP_TITLE: 'Route Map',
  ROUTE_MAP_DESC:
    'Klik op de map om de route-editor te openen. In de route-editor kun je de route wijzigen, stops toevoegen en meer.',
  TRAVEL_MODE: 'manier van reizen',
  FILTER_OPTIONS: 'Filter opties',

  APPLY: 'Toepassen',
  PREVIEW: 'Preview',

  START: 'Inflow batchdetails',
  END: 'Outflow batch details',
  'DATE/TIMEINFO': 'Algemene batchgegevens met alle andere velden',
  PRICECATEGORIES: 'Batch prijsdetails',
  PERIOD_INFO: 'Details van batchduur van tijdsduur',
  // Tool Bar
  FINANCIAL_MANAGEMENT: 'Financieel Management',
  THEME_LIST: 'Homepage',
  THEMES: 'Highlights',
  STATISTICS: 'Statistieken',

  // home
  REGISTER: 'Registreren',
  REGISTER_HEAD: 'Aanmelden',
  WHY_REGISTER: `Waarom aanmelden voor de ${appConfig.dss.environmentName}-app?`,
  REGISTER_LIST: `Geniet maximaal van de ${appConfig.dss.environmentName} met de exclusieve voordelen voor app-gebruikers!  `,
  REGISTER_CONFIRMATION_EMAIL:
    'We hebben je een bevestigingsmail gestuurd met een link om je account te activeren.',
  REGISTER_SPAM_WARNING:
    'Controleer uw spam-map voor het geval u geen bevestigingsmail heeft ontvangen.',
  REGISTER_LIST_1: 'Blijf op de hoogte van je favoriete events. ',
  REGISTER_LIST_2: 'Maak kans op mooie prijzen. ',
  REGISTER_LIST_3:
    'Koop je parkeerticket online en je kunt direct inrijden zonder gedoe met cash geld. ',
  REGISTER_LIST_4: 'Ontvang exclusieve aanbiedingen en kortingen.',
  REGISTER_LIST_5: 'Vind makkelijk je weg met de interactieve kaart. ',
  REGISTER_LIST_6: `Meld je nu aan en download de ${appConfig.dss.environmentName}-app in de App Store of Google Play. `,
  REGISTER_NOW: 'Aanmelden',
  // register
  REGISTER_DETAILS: 'Persoonsgegevens',
  REGISTER_DETAILS_INFO:
    'We hebben enkel wat informatie nodig van u, om een account aan te maken! ',
  REGISTER_INFO: 'Waarom vragen we deze informatie?',
  REGISTER_PHONE: 'Mobiel telefoonnummer: ',
  REGISTER_PHONE_TEXT:
    'wordt gebruikt om je op de hoogte te houden met sms als de app niet werkt.',
  REGISTER_VIP: 'Speciale Code: ',
  REGISTER_VIP_TEXT:
    'heb je een speciale code ontvangen? Vul deze dan hier in. Geen speciale code ontvangen? Laat het veld dan leeg. ',
  REGISTER_ZIPCODE: 'Postcode: ',
  REGISTER_ZIPCODE_TEXT:
    'wordt gebruikt om inzicht te krijgen waar onze bezoekers vandaan komen, zodat we bezoekers kunnen informeren over de beste aanrijroute. ',
  REGISTER_LICENSE: 'Kenteken: ',
  REGISTER_LICENSE_TEXT:
    'reis je per auto naar het evenement? Geef je kenteken op voor snelle toegang tot de parkeerplaats. ',
  REGISTER_CHECKBOX: 'Ik ga akkoord met de',
  REGISTER_PRIVACY_STATEMENT: 'Privacy regelement',
  AGREE_PRIVACY_STATEMENT:
    'Door een account aan te maken ga je akkoord met ons',
  REGISTER_KEEP_ME_UP_TO_DATE: `Ja, houd me op de hoogte over de ${appConfig.dss.environmentName}`,
  REGISTER_FORM_NAME: 'Naam',
  REGISTER_FORM_LASTNAME: 'Achternaam',
  REGISTER_FORM_EMAIL: 'E-mail',
  REGISTER_FORM_PHONE: 'Mobiel telefoonnummer',
  REGISTER_FORM_ZIP: 'Postcode',
  REGISTER_FORM_COUNTRY: 'Land',
  REGISTER_FORM_VIP: 'Speciale code',
  REGISTER_FORM_LICENSE: ' Kenteken auto',
  REGISTER_ACCOUNT: 'Registreer een account',
  REGISTER_INTEREST_TITLE: 'Interesses',
  REGISTER_INTEREST:
    'Laat ons weten waar je geintresseerd in bent, zodat we jou events kunnen laten tonen op basis van je interesses.',
  REGISTER_ACCOMPANY:
    'Let us know who will accompany you, so we can help you pick suitable events.',
  REGISTER_ACCOMPANY_TITLE: 'I will visit with',
  REGISTER_ACCOUNT_EXIST:
    'Account bestaat. U kunt inloggen met uw PG_NAME-account.',
  REGISTER_ACCOUNT_EXIST_CURR_PG:
    'Account bestaat. U kunt direct inloggen of uw wachtwoord opnieuw instellen als u het bent vergeten.',
  REGISTER_ACCOUNT_NOT_ACTIVATED:
    'Account aangemaakt maar nog niet geactiveerd. Ga naar je mailbox om je account te activeren.',
  REGISTER_ACCOUNT_RESEND_ACTIVATION_EMAIL:
    'Heb je de activeringsmail niet ontvangen? Klik op de onderstaande knop om de e-mail opnieuw te verzenden.',
  RESEND_ACTIVATION_MAIL_SUCCESS_TITLE:
    'De activeringsmail is naar uw mailbox verzonden. Controleer uw e-mail en activeer uw account.',
  GENERATE_PASS: 'Genereer wachtwoord',

  REGISTER_VISIT_WITH: `I will visit ${appConfig.dss.environmentName} with`,
  REGISTER_MYSELF: 'Ikzelf',
  REGISTER_PARTNER: 'Mijn Partner',
  REGISTER_FRIENDS: 'Vrienden',
  REGISTER_KIDS: 'Kinderen',
  REGISTER_SCHOOL: 'School',

  SUCCES_REGISTER: 'Joepie! Uw account is aangemaakt',
  SUCCES_REGISTER_TEXT_1:
    'Gefeliciteerd! Ga door naar de volgende stap om aan te geven op welke datum(s) je ons komt bezoeken. ',
  SUCCES_REGISTER_TEXT_2: `Hier is uw unieke activatiecode. Met deze code activeert u de ${appConfig.dss.environmentName}-app na downloaden en installatie. U ontvangt je activatiecode ook per mail, met instructies over hoe je de app downloadt en activeert.  `,
  SUCCES_REGISTER_USER_ID: 'Jouw activatiecode: ',
  DOWNLOAD: 'Download de app',
  APPLE: 'voor Apple',
  ANDROID: 'voor Android',

  TAGS: 'Tags',
  TAGS_EVENT: 'Selecteer je tags',
  TAGS_TEXT:
    'Selecteer de tags die u leuk vindt, zodat we u gebeurtenissen in verband met deze tags kunnen laten zien.',
  TAGS_REQ: 'Selecteer de tags',

  // Ticket
  TICKET_NEW: 'Nieuw tickettype',
  TICKETS_PRICING_EXPLANATION:
    'Omdat de prijsstelling extern wordt beheerd, is er geen mogelijkheid om een ​​ticket toe te voegen',
  TICKET_SOME_EXPLANATION: 'Enige uitleg over soorten tickets',
  TICKET: 'Tickets',
  TICKET_EVENT: 'Selecteer je evenementen',
  TICKET_TEXT: `Selecteer de datum(s) dat je de ${appConfig.dss.environmentName} wilt bezoeken, dan houden we je op de hoogte over relevant ${appConfig.dss.environmentName} nieuws. Je kunt ook meteen tickets boeken voor bepaalde attracties.`,
  TICKET_WARNING: 'Let op:',
  TICKET_TEXT_1:
    'Koop nu direct je parkeerticket door "Parking" aan te vinken. Je hebt meer kans te parkeren zonder in de rij te staan. ',
  TICKET_TEXT_2:
    'online gekochte tickets zijn niet overdraagbaar en niet retourneerbaar. Je ontvangt je tickets per e-mail binnen 30 minuten na betaling. ',
  TICKET_TEXT_3: 'Door online tickets te kopen ga je akkoord met onze',
  TICKET_TEXT_4: 'Welke attracties wil zeker niet missen?',
  TICKET_TEXT_5:
    'Reserveer alvast een ticket voor je favoriete attracties. Geef ze een prioriteit mee: welke wil je zeker ervaren? Zo kunnen wij op voorhand alvast een plek voor je reserveren.',
  TICKET_TEXT_6:
    'Als je ‘fixed’ selecteert krijg je een vast programma voor jouw favouriete attracties. Als je ‘flexible’ selecteert wordt gedurende de dag jou de mogelijkheid geboden om een plek te reserveren voor jouw favouriete attracties. ',
  TICKET_TEXT_TERMS: 'algemene voorwaarden.',
  TICKET_ATTEND: `Selecteer de dagen dat je de ${appConfig.dss.environmentName} wilt bezoeken.`,
  TICKET_ARRIVING: 'Wat is je verwachte aankomsttijd?',
  TICKET_INFORMATION:
    'Kaartjes worden afgehandeld door de evenementenorganisatie.',
  TICKET_INFORMATION2: 'Ter plaatse kan een toegangsprijs worden berekend.',
  DOUBLEUSERGROUP_ERROR:
    'Sorry, je kan maar 1 partner groep aan een gebruiker linken.',
  DUPLICATEDPARTNERNAME_ERROR:
    'Sorry, de naam van de partner bestaat al in het systeem, verander alstublieft de naam en probeer het nogmaals.',

  // Linda output
  TRIPS: 'Trips',
  TRIP_WELCOME: 'Welkom in jouw trip lijst',
  TRIP_CHOICE:
    'Selecteer een trip die je reeds aangemaakt hebt om te bekijken of te verwijderen. In het geval dat er geen trip beschikbaar is, klik op het "+" icoon rechtsbovenin om een trip aan te maken voor dit event',
  TRIP_STARTED: 'Laten we jouw trip personaliseren',
  TRIP_EVENT_PICKER:
    'Maak een keuze uit de volgende events om te bezoeken. Mocht je na afloop toch een ander event willen bezoeken, kun je altijd een nieuwe trip aanmaken!',
  TRIP_DATEPICKER:
    'Nu je een keuze hebt gemaakt naar welk event je toe wilt, laten we de dag kiezen waarop jij naar het event toe wilt gaan. Kies gerust de best passende dag voor jou uit.',
  TRIP_TICKETS: 'Download tickets',
  TRIP_PLAN: 'Plan mijn trip',

  PAYMENT: 'Bevestig je keuzes ',
  PAYMENT_TEXT:
    'Controleer je ingevoerde gegevens en bevestig je keuzes om je registratie te voltooien. ',
  PAYMENT_CONFIRM: 'Voltooien',
  PAYMENT_CONFIRM_PAY: 'Voltooien en betalen',
  PAYMENT_OVERVIEW: 'Overzicht van events:',
  TOTAL_PRICE: 'Totale prijs:',
  ARRIVAL_INFO: 'Geselecteerde dagen:',
  ARRIVAL_TIME: 'Verwachte aankomsttijd: ',

  TICKET_SUCCES: 'Hoera! We kijken uit naar je komst.',
  TICKET_SUCCES_1: `Je registratie is voltooid.We wensen je veel plezier bij de ${appConfig.dss.environmentName}!`,
  TICKET_SUCCES_2: `Download en activeer nu de ${appConfig.dss.environmentName}-app om kans te maken op mooie prijzen. We wensen je veel plezier bij de ${appConfig.dss.environmentName}.`,

  TICKET_ORDER: 'Tickets bestellen',
  TICKET_ORDER_1: 'Bevestig uw bestelling',
  TICKET_ORDER_2: '',
  EVENT_PAYMENT: 'Betalings proces',
  EVENT_PAYMENT_INFO:
    'U wordt doorgestuurd naar Mollie payments om uw betaling af te maken',
  EVENT_PAYMENT_INFO_1: '',

  // reorder alerts
  SUCCESS_PROD: 'De volgende items zijn toegevoegd aan Uw winkelwagen:',
  FAIL_PROD:
    'De volgende items konden niet worden toegevoegd aan Uw winkelwagen:',

  // payments status error
  EXPIRED: 'Verlopen',
  CANCELED: 'beeindigt',
  FAILED: 'Mislukt',

  STATUS_CONFIRMED: 'Bevestigd',
  STATUS_PARTNER_CONFIRM: 'Wachten op bevestiging',
  STATUS_REQUESTED_PAYMENT: 'Wachten op betaling',

  ERROR_HEADER: 'Het lijkt erop dat er iets is mis gegaan.',
  ERROR_NO_CONNECTION:
    'Er is een probleem tot stand gekomen, neem contact op met de customer support center van The Driving Force',

  TICKET_UNSUCCESSFUL: 'Sorry, je betaling is niet geslaagd. ',
  TICKET_UNSUCCESSFUL_TEXT:
    'Probeer het nog een keer alsjeblieft. Het is vast een tijdelijke storing. Werkt het nog steeds niet, neem dan contact op met de klantenservice van The Driving Force via  customerservice@thedrivingforce.nl of bel +31 297 51 44 55. ',
  RETRY: 'Opnieuw proberen',

  SUCCES_PAYMENT: 'Hoera! Je betaling is geslaagd. ',
  SUCCES_PAYMENT_1:
    'Je registratie is voltooid. Je ontvangt van ons een bevestiging per e-mail met jouw tickets. We kijken uit naar je komst. ',
  SUCCES_PAYMENT_2: `Download en activeer nu de ${appConfig.dss.environmentName}-app om kans te maken op mooie prijzen. We wensen je veel plezier bij de ${appConfig.dss.environmentName}.`,
  Website_Down_1: 'Tot onze spijt is de website tijdelijk niet beschikbaar',
  Website_Down_2:
    'We werken er aan om de site zo snel mogelijk online te krijgen.',

  NO_RELATION: 'Geen relatie',
  NO_TRAFFIC_OBJECTS: 'Geen verkeersobjecten',
  NO_SENSOR_ACTUATOR: 'Geen actuators van sensoren',
  NO_EVENTS: 'Geen evenementen',
  NO_EVENTS_AVAILABLE: 'Geen evenementen beschikbaar',
  ADD_RELATION: 'Relatie toevoegen',
  ADD_INCIDENT: 'Voeg incident toe',
  ADD_TRAFFIC_OBJECT: 'Voeg verkeersobject toe',
  ADD_SENSOR_ACTUATOR: 'Sensor of actuator toevoegen',
  ADD_EVENTS: 'Voeg evenementen toe',
  NO_ENTRY_EXIT_POINTS: 'Geen in/uitgangen',
  ENTRY_EXIT_POINTS: 'In en uitgangen',
  INCIDENTS: 'Incidents',
  RELATIONS: 'Relaties',
  TRAFFIC_OBJECTS: 'Verkeersobjecten',
  SENSOR_ACTUATOR: 'Sensoren / actuators',
  EVENTS: 'Evenementen',
  SAVE_RELATION: 'Relatie opslaan',
  MAKE_ROUTE: 'Route aanmaken',

  // Batchgroup

  BATCHGROUP_NAME: 'Naam van de batchgroup',
  BATCHGROUP_DESCRIPTION: 'Beschrijving van de batchgroup',
  BATCHGROUP_CHAINBOX: 'Batchgroup bevat chainable batches',
  BATCHGROUP_DELETE: 'Verwijder batchgroup',
  BATCHGROUP_CONF_DELETE:
    'Weet je zeker dat je de volgende batchgroup wilt verwijderen: ',
  BATCHGROUP_EDIT: 'Wijzig batchgroup',
  BATCHGROUP_STARTTIME: 'Starttijd van de batchgroup',
  BATCHGROUP_ENDTIME: 'eindtijd van de batchgroup',
  BATCHGROUP_INTERVAL: 'Batches starten iedere ..(min)',
  BATCHGROUP_INTERVAL_END: 'Batches eindige iedere ..(min)',
  BATCHGROUP_STARTDATE: 'Startdatum van de batchgroup',
  BATCHGROUP_ENDDATE: 'Einddatum van de batchgroup',
  BATCHGROUP_DATES: 'Datums van de batchgroup',
  BATCHGROUP_CAPACITYPERBATCH: 'Capaciteit per batch',
  BATCHGROUP_DURATION: 'Duur van een batch',
  BATCHGROUP_TYPERE: 'Terugkerende data',
  BATCHGROUP_ADD: 'Voeg een batchgroup toe',
  BATCHGROUP_DETAILS: 'Batchgroup details',
  BATCHGROUP_CHOOSETYPE: 'Kies een batchgroup type',
  BATCHGROUP_DAYS: 'Selecteer de dagen waarin het event voorkomt',
  BATCHGROUP_NOPASTDATE:
    'Selecteer alstublieft een datum die niet in het verleden valt',
  BATCHGROUP_TYPESP: 'Specifieke datum(s)',

  // External calendar
  EXTERNAL_CALENDAR: 'Externe kalender',
  EXTERNAL_CALENDAR_ADD: 'Voeg externe kalender',
  EXTERNAL_CALENDAR_DELETE: 'Verwijder externe agenda',
  EXTERNAL_CALENDAR_CONF_DELETE:
    'Weet u zeker dat u de volgende agenda wilt verwijderen: ',

  // Products
  PRODUCT_CATEGORIES: 'Productcategorieën',
  PRODUCT_CATEGORY_EXPLANATION:
    'Om een ​​productcategorie voor dit evenement toe te voegen, moet u het evenement eerst opslaan!',
  PRODUCT_ADD_CATEGORY: 'Productcategorie toevoegen',
  PRODUCT_IN_STOCK: 'Op voorraad',
  PRODUCT_DELETE: 'Verwijder product',
  PRODUCT_ASPECT_DELETE: 'Verwijder aspect',
  PRODUCT_ITEM_DELETE: 'Verwijder item',
  PRODUCT_PRICE_CATEGORY_DELETE: 'Verwijder prijs categorie',
  PRODUCT_CONF_DELETE:
    'Weet u zeker dat u het volgende product wilt verwijderen: ',
  PRODUCT_ASPECT_CONF_DELETE:
    'Weet u zeker dat u het volgende aspect wilt verwijderen: ',
  PRODUCT_PRICE_CATEGORY_CONF_DELETE:
    'Weet u zeker dat u de gekozen prijs categorie wilt verwijderen? ',
  PRODUCT_ITEM_CONF_DELETE:
    'Weet u zeker dat u het gekozen item wilt verwijderen? ',
  VIEW_PRODUCT: 'Overzicht product',
  CREATE_PRODUCT: 'Product toevoegen',
  PRODUCT_NAME: 'Naam van het product',
  PRODUCT_PRICE: 'Prijs van het product',
  PRODUCT_DESCRIPTION: 'Omschrijving van het product',
  PRODUCT_VAT: 'BTW % van het product',
  PRODUCT_BRAND: 'Merk naam van het product',
  PRODUCT_PICTURE: 'Afbeelding van het product',
  PRODUCT_CATEGORIES: 'Categorieën van het product',
  PRODUCT_CAPACITY: 'Product capaciteit',
  PRODUCT_AGE: 'Minimale leeftijd voor product',
  PRODUCT_CATEGORY: 'Product categorie',
  PRODUCTS_ADD_MORE: 'Voeg meer toe',
  PRODUCT_SOLD_OUT: 'Uitverkocht',
  PREPARATION_INSTRUCTION_BTN: 'Instructie',
  PREPARATION_INSTRUCTION_TITLE: 'Bereidingsinstructie',
  PRODUCT_LEAD_TIME_ALERT: 'Dit product heeft een minimale levertijd van',
  PRODUCT_DATE_TIME_ALERT: 'Dit product kan besteld worden van',
  PRODUCT_DATE_TIME: 't/m',
  INCL_VAT_TEMPLATE: 'incl. %s BTW',
  EXCL_VAT_TEMPLATE: 'excl. %s BTW',
  INCL_VAT: 'incl. BTW',
  EXCL_VAT: 'excl. BTW',

  // Rental
  RENTAL_PERIOD: 'Kies een datum',
  CHECK_AVAILABILITY: 'sla mijn periode info op',

  // Login
  LOGIN_YOUR_EMAIL: 'Uw e-mailadres',
  LOGIN_YOUR_PASSWORD: 'Uw wachtwoord',
  LOGIN_NO_ACCOUNT_YET: 'Nog geen account?',
  LOGIN_ACCOUNT_CREATION: 'Account aanmaken',
  LOGIN_REPEAT_EMAIL: 'Herhaal uw e-mailadres',

  // Linda input
  LINDA_SUGGESTIONS_DIALOG: 'Linda is de suggesties aan het ophalen',
  LINDA_FOOD_AND_BEVERAGE:
    'Hier kunt u nog wat te eten of te drinken vooraf of erna boeken',
  LINDA_ADD_FOOD_BEFORE: 'Voeg eten en drinken toe voor het event',
  LINDA_ADD_FOOD_AFTER: 'Voeg eten en drinken toe na het event',
  LINDA_BIGGER_GAP_OR_GROUPSIZE:
    'Probeer het tijdsgat groter te maken en/of de groep grootte kleiner.',
  LINDA_SEARCHING: 'Linda is aan het zoeken naar het geselecteerde event',
  LINDA_LOGIN_WELCOME: 'Hoi hoi, ik ben Linda.',
  LINDA_LOGIN_HELPING_HAND:
    'Ik help je graag bij het inplannen van jouw dagje weg, zodat jij het beste uit je dag kan halen en de drukte kan omzeilen.',
  LINDA_LOGIN_SHORT_INFO:
    'Linda helpt je binnen vijf minuten een afspraak te maken waarmee je straks uren wachten bespaart!',
  LINDA_WELCOME: 'Welkom!',
  LINDA_REGISTER_USERINFO:
    'Om te beginnen heb ik deze gegevens nodig, zodat ik weet voor wie ik plan.',
  LINDA_REGISTER_LATER:
    'Zo kan ik jou ook later nog op de hoogte houden van je afspraak',
  LINDA_REGISTER_DONE: 'Bedankt voor het registreren!',
  LINDA_REGISTER_MAIL:
    'Klaar! Bedankt voor het aanmaken van je accountName paspoort. We hebben je een bevestigingsmail gestuurd met een link om je paspoort te activeren. Klik op de link om je paspoort te activeren alsjeblieft. Heb je de mail net gehad? Controleer je spam folder alsjeblieft. ',
  LINDA_ACCOUNT_CREATION: 'Welkom!',
  LINDA_ACCOUNT_CREATION_FIRST_STEP: 'Super! Je account is aangemaakt',
  LINDA_ACCOUNT_CREATION_FIRST_STEP_DESC:
    'Ik heb je een mail toegestuurd met een link, \nklik op de link om je account te activeren',
  LINDA_WELCOME_BACK: 'Welkom terug!',
  LINDA_ACCOUNT_READY_TO_CREATE:
    'Om te beginnen zou ik graag willen weten wie je bent, zodat we snel een account voor je aanmaken',
  LINDA_USER_TRIPLIST:
    'Bekijk jouw geplande afspraken of maak een nieuwe. Door op een afspraak te klikken, kun je ook gelijk de tickets ophalen.',
  LINDA_WHERE_TO: 'Waar wil je naartoe?',
  LINDA_SEARCH_EVENT: 'Kies een evenement om door te gaan',
  LINDA_DATE_PICKER_WELCOME: 'Oke dan, laten we een datum kiezen.',
  LINDA_DATE_PICKER: 'Wanneer ben je van plan te gaan?',
  LINDA_SPECIAL_CODE:
    'Heb je toevallig ook nog een speciale code gekregen in de mail?',
  LINDA_TRIP_DETAIL:
    'Met wie wil je er heen en hoelaat denk je ongeveer aan te willen komen en weer te vertrekken?',
  LINDA_ACTIVITY_LIST:
    'Ook wil ik graag een lijstje opstellen van wat je daar wilt zien en doen. Dan zorg ik ervoor dat je overal heen kunt.',
  LINDA_ADJUST_INFO: 'Deze gegevens kan je later nog aanpassen.',
  LINDA_MODE_OF_TRANSPORT: 'Hoe ben je van plan om te reizen?',
  LINDA_SAVING_A_SPOT:
    'Zo kan ik je helpen bij het vrijhouden van een parkeerplek of controleren of er openbaar vervoer beschikbaar is.',
  LINDA_CHECK_INPUT:
    'Controleer even alle gegevens, zodat we zeker weten dat er niks mis kan gaan.',
  LINDA_MEETING_SET: 'Het boekingsproces is afgerond',
  LINDA_MEETING_SET2:
    'Uw boekingsaanvraag is ter bevestiging doorgestuurd naar onze partner.',
  LINDA_ERROR: 'Er is iets misgegaan.',
  LINDA_ERROR_PAYMENT:
    'Je betaling is nog niet ontvangen. Controleer je account.',
  LINDA_ADJUST_TIME:
    'Je kunt de tijden en het vervoer nog aanpassen wanneer deze niet meer kloppen.',
  REGISTER_LINDA: 'Aanmelden',
  LINDA_EVENT_NAME: 'Naam van het evenement',
  LINDA_VIP: 'kortings code',
  LINDA_VIP_DIALOG:
    'Als je een kortings code ontvangen hebt, kun je dit hieronder invullen of klik op volgende.',
  LINDA_USERGROUP_DIALOG:
    'Als je een speciale code ontvangen hebt, kun je dit hieronder invullen',
  LINDA_VIP_INPUT: 'Vul hier je kortings code in',
  LINDA_GROUP_SIZE: 'Groep grootte',
  LINDA_GS_INPUT: 'Aantal',
  LINDA_ARRIVAL: 'Verwachte aankomst',
  LINDA_ARRIVAL_LABEL: 'Aankomst tijd',
  LINDA_DEPARTURE_LABEL: 'Vertrek tijd',
  LINDA_DEPARTURE: 'Verwachte vertrek',
  LINDA_TRANSPORT_TYPE: 'Transport type',
  LINDA_ATTEND: 'Wat zou je willen doen?',
  LINDA_NO_SUBEVENTS: 'Er zijn geen activiteiten beschikbaar',
  LINDA_FILL_REQUIRED: 'Vul alsjeblieft alle velden in',
  LINDA_NEW_APPOINTMENT: 'Nieuwe afspraak',
  LINDA_APPOINTMENTS: 'Jouw afspraken',
  LINDA_NO_APPOINTMENTS: 'Geen afspraken',
  LINDA_GO_TO_APPOINTMENTS: 'Ga naar mijn activiteiten',
  LINDA_ORDER: 'Uw bestelling',
  LINDA_STARTTIME: 'Starttijd',
  LINDA_ENDTIME: 'Eindtijd',
  LINDA_DELETE_APPOINTMENT:
    'Weet je zeker dat je je afspraak wilt verwijderen?',
  LINDA_CALENDAR_CROWDED: 'Druk',
  LINDA_CALENDAR_CALM: 'Rustig',
  LINDA_CALENDAR_AVERAGE: 'Gemiddeld',
  LINDA_CALENDAR_SELECTED: 'Geselecteerd',
  LINDA_TRANSPORT_MODE: 'Transport keuze',
  LINDA_NO_TRANSPORT_AVAILABLE: 'Er is geen transport beschikbaar',
  LINDA_MANDATORY_TRANSPORT:
    'Selecteer alsjeblieft een transport keuze om door te gaan',
  LINDA_TOTAL_PRICE: 'Totale prijs',
  LINDA_CANCEL_ORDER: 'Annuleer',
  LINDA_CONFIRM_ORDER: 'Bevestig',
  LINDA_ORDER_FAILED:
    'De afspraak is verwijderd, controleer alsjeblieft je mail voor de instructies.',
  CLOSE: 'Sluiten',
  LINDA_REGISTER_TO: 'Registreer om...',
  LINDA_MISS_NOTHING: 'Niets te missen',
  LINDA_OWN_PROGRAM: 'Stel je eigen programma samen',
  LINDA_AVOID: 'Rijen te vermijden',
  LINDA_PLAN_VISIT: 'Plan je bezoek met Linda',
  LINDA_ENJOY: 'Maximaal te genieten',
  LINDA_ADVANTAGE: 'Profiteer van extras en kortingen',
  LINDA_NONE: 'Geen',
  LINDA_PLANNED_SUCCESSFULL: 'Er is een bevestigingsmail verstuurd',
  LINDA_PLANNED_SUCCESSFULL2:
    'U ontvangt een bericht wanneer de partner uw boekingsaanvraag heeft bevestigd of afgewezen.',
  LINDA_KEEPS_PROMISE: 'De afspraak is terug te vinden in mijn activiteiten',
  LINDA_TICKETS_TO_MAIL: 'Ik heb de tickets in de mail naar je toe gestuurd!',
  LINDA_TICKET_INFO_ACCOUNT:
    'Ook kun je de tickets altijd terug vinden bij de informatie over jouw afspraak.',
  LINDA_ACCOUNT_MADE_TITLE:
    'Super! Je account is aangemaakt. Om je account te activeren heb ik de stijl van het bedrijf nodig.',
  LINDA_ACCOUNT_MADE_BODY:
    'Ik zal er voor zorgen dat jouw account eruitziet alsof het bij jouw bedrijf hoort!',
  LINDA_BG_MEANING:
    'Om de gebruikers over uw faciliteiten te verspreiden, moet u batchgroups maken. Deze batchgroups bestaan uit verschillende batches',
  LINDA_BG_FILLING:
    'Hiermee kan ik de gebruikers indelen voor verschillende batches en ervoor zorgen dat alle batches goed zijn gevuld',

  LINDA_THEME: 'Thema',
  LINDA_GETTING_EVENTS: 'Linda is alle events aan het ophalen',
  LINDA_CHECK_YOUR_ORDER: 'Controleer uw bestelling',
  LINDA_PLEASE_FILL_IN: 'Vul alstublieft de velden in',

  // Web stepper two

  STEP_THEME: 'Selecteer een thema',
  STEP_DETAILS: 'Trip details',
  STEP_WISHLIST: 'Verlanglijst',
  STEP_PLAN: 'Plan je dag',
  STEP_TRANSPORT: 'Transport keuze',
  STEP_ISSUES: 'Issues',
  STEP_CONFIRM: 'Bevestiging',

  CREATE_EVENT: 'Nieuw Event',

  // Event
  EVENT_ADD_REWARD_LEVEL: 'Beloningsniveau toevoegen',
  EVENT_ASSIGN_REWARDS: 'Wijs beloningen toe',
  EVENT_REWARD_MANAGEMENT: 'Beloningsbeheer',
  EVENT_ASSIGN_REWARD_EXPLANATION:
    'Sla het evenement eerst op om een ​​beloning aan dit evenement toe te kennen!',
  EVENT_REWARD_EXPLANATION:
    'Sla het evenement eerst op om een ​​beloningsniveau aan dit evenement toe te voegen!',
  EVENT_DISCOUNT_CARDS_EXPLANATION:
    'Sla het evenement eerst op om een ​​kortingskaart toe te voegen!',
  EVENT_DISCOUNT_CARDS: 'Kortingskaarten',
  EVENT_SUBACTIVITIES: 'SubActiviteiten',
  EVENT_ALTERNATIVES: 'Alternatieven',
  EVENT_TICKET_TYPES: 'Tickettypen',
  EVENT_EXTRA: 'Extra evenement',
  EVENT_STOP_NAME: 'Naam stop evenement',
  EVENT_END_LOCATION: 'Eind locatie',
  EVENT_START_LOCATION: 'Start locatie',
  EVENT_LOCATION: 'Evenement locatie',
  EVENT_ROUTE: 'Evenement route',
  EVENT_RESET: 'Opnieuw instellen',
  EVENT_RANKING: 'Evenement ranking',
  EVENT_PARTNER: 'Evenement partner',
  EVENT_PRODUCT: 'Evenement/Producten',
  EVENT_DATE_RANGE: 'Datumbereik',
  EVENT_AGE_RESTRICTIO: 'Leeftijdsbeperking',
  EVENT_ACTIVE_COMPLETE_TIME: 'Activeer compleet tijd',
  EVENT_CHECK_IN_TIME: 'Incheck tijd',
  EVENT_CHECK_OUT_TIME: 'Uitcheck tijd',
  EVENT_ACTIONS: 'Acties',
  EVENT_EARLIEST_CHECKIN_TIME: 'Vroegste incheck tijd',
  EVENT_LATEST_CHECKIN_TIME: 'Laatste incheck tijd',
  EVENT_DURATION_ARRIVAL_BATCHES: 'Duur aankomst batches',
  EVENT_MAX_INFLOW: 'Max instroom',
  EVENT_EARLIEST_CHECKOUT_TIME: 'Vroegste uitcheck tijd',
  EVENT_LATEST_CHECKOUT_TIME: 'Laatste uitcheck tijd',
  EVENT_DURATION_DEPARTURE_BATCHES: 'Duur vertrek batches',
  EVENT_MAX_OUTFLOW: 'Max uitstroom',
  EVENT_STEPS: 'Stappen',
  EVENT_MINIMAL_DURATION: 'Minimale duur',
  EVENT_MAXIMUM_DURATION: 'Maximale duur',
  EVENT_BOOKING_POLICY: 'Boeking beleid',
  EVENT_FLEX_PERCENTAGE: 'Flex percentage',
  EVENT_PRICE_CATEGORY: 'Prijs categorie',
  EVENT_ADD_PRICE_CATEGORY: 'Voeg prijs categorie',
  EVENT_THRESHOLD: 'Drempel',
  EVENT_PLEASE_ADD_PRICECATEGORY:
    'Voeg tenminste 1 prijs categorie toe aan de batchgroep',
  EVENT_EXTERNAL_PLATFORM: 'Externe platforms',
  EVENT_TOUR: 'Tours',
  EVENT_PRICE_INFORMATION: 'Prijs informatie',
  EVENT_CHART_EXPLANATION:
    'Als je een keuze maakt voor een datum en een locatie, wordt er een grafiek gemaakt om de drukte te laten zien.',
  EVENT_AVERAGE_SPEED: 'Gemiddelde snelheid (km/u)',
  EVENT_INSERT_STARTTIME: 'Voeg jouw nieuwe starttijd toe',
  EVENT_INSERT_ENDTIME: 'Voeg jouw nieuwe eindtijd toe',
  EVENT_CURRENT_START_AND_ENDTIME:
    'Jouw huidige start- en eindtijd voor event: eventName is',
  EVENT_CURRENT_START_AND_ENDDATE:
    'Jouw huidige start- en einddatum voor event: eventName is',
  EVENT_NO_TICKETS_SELECTED: 'Geen event tickets geselecteerd',
  EVENT_PLEASE_SELECT_TICKET: 'Selecteer alstublieft de gewenste tickets',
  EVENT_NO_DATE_CHOSEN: 'Geen datum gekozen',
  EVENT_CHOOSE_DATE: 'Kies alstublieft een datum',
  EVENT_BOOK: 'Boek Event',
  EVENT_INPUT_TIME_INCORRECT: 'De start tijd is later dan de eind tijd',
  EVENT_TIME_INCORRECT: 'Tijd niet correct',
  EVENT_PREFERRED_ARRIVAL: 'Voorkeur voor aankomsttijd',
  EVENT_PREFERRED_DEPARTURE: 'Voorkeur voor vertrektijd',
  EVENT_STARTS_EVERY: 'Start elke',
  NO_EVENT: 'No events found',
  NO_EVENTS_NOW_FOR_PARTNER:
    'Er zijn geen events gevonden voor de huidige partner',
  NO_EVENTS_NOW_FOR_ACCOUNT:
    'Er zijn geen events gevonden voor de huidige account',
  SELECTED_EVENT: 'Het geselecteerde event',
  EVENT_NAME: 'Naam van event',
  EVENT_TYPE: 'Type van event',
  EVENT_EDIT: 'Selecteer een event om te wijzigen',
  EDIT_EVENT: 'Wijzig event',
  EVENT_REGISTRATION: 'Event registratie',
  EVENT_DESCRIPTION: 'beschrijving van het event',
  EVENT_DESC_SHORT: 'Omschrijving',
  EVENT_LOC_SHORT: 'Locatie',
  EVENT_CAP_SHORT: 'Capaciteit',
  EVENT_CAT_SHORT: 'Categorieen',
  EVENT_PIC_SHORT: 'Afbeelding',
  EVENT_MESSAGE_PICTURE: 'Bericht afbeelding',
  EVENT_MESSAGE_PRODUCT: 'Product',
  EVENT_MESSAGE_PRODUCT_OPT: 'Product (optioneel)',
  EVENT_MESSAGE_SELECT_PRODUCT: 'Selecteer een product',
  EVENT_BUDGET_SHORT: 'Budget',
  EVENT_PARTOF_SHORT: 'Onderdeel van -Themas-',
  EVENT_TW_SHORT: 'Tijdvenster',
  EVENT_PIC_NONE: 'Geen afbeelding beschikbaar',
  EVENT_VISIBILITY: 'Zichtbaar voor',
  EVENT_STARTTIME: 'Starttijd van het event',
  EVENT_ENDTIME: 'eindtijd van het event',
  EVENT_INTERVAL: 'Interval',
  EVENT_MAXCAPACITY: 'Maximale capaciteit per interval',
  EVENT_INFLOWCAPACITY: 'Capaciteit per interval',
  EVENT_PRICE: 'Event prijs',
  EVENT_MAX_WAIT_TIME: 'Maximale wachttijd in minuten',
  EVENT_HISTORIC_ARRIVAL: 'Historische aankomsten',
  EVENT_FLEX_ARRIVAL: 'Percentage flexible users',
  EVENT_AVERAGE_WAITTIME: 'Gemmidelde wachttijd',
  EVENT_MAX_WAITTIME: 'Maximale wachttijd',
  EVENT_AVERAGE_DEVIATION: 'Gemiddelde afwijking',
  EVENT_MAX_DEVIATION: 'Maximale afwijking',
  EVENT_DURATION: 'Duur van event',
  EVENT_LANGUAGE: 'Taal specificaties',
  EVENT_FILTERTYPE: 'Filter events op type: ',
  EVENT_AGENDA_NEW: 'Nieuw agenda item',
  EVENT_DATES_SELECTION: 'Selectie van datums',
  EVENT_DAYS_SELECTION: 'Selectie van dagen',
  EVENT_START_DATE: 'Start-datum',
  EVENT_END_DATE: 'Eind-datum',
  EVENT_START_TIME: 'Start-tijd',
  EVENT_END_TIME: 'Eind-tijd',
  EVENT_MAX_INFLOW: 'Maximale instroming',
  EVENT_RATE_PRICE: 'Tarief prijs',
  EVENT_REWARD_POINTS: 'Reward points',
  EVENT_NO_BATCHGROUPS: 'Geen agenda items beschikbaar',
  EVENT_MESSAGE_TITLE: 'Bericht titel',
  EVENT_MESSAGE_TEXT: 'Bericht tekst',
  EVENT_MESSAGE_REW_LVL: 'Verstuur bericht naar belong niveau',
  EVENT_USER_SELECTION: 'Selectie van gebruikers',
  EVENT_DATE: 'Datum',
  EVENT_TIME: 'Tijd',
  EVENT_COMM_TYPE: 'Communicatie type',
  EVENT_MESSAGE_STATUS: 'Bericht status',
  EVENT_MESSAGE_SEND: 'Verstuurd',
  EVENT_MESSAGE_NOT_SEND: 'Niet verstuurd',
  EVENT_ERROR_MSG_1:
    'Het lijkt erop dat je niet alle verplichte velden (correct) hebt ingevuld.',
  EVENT_ERROR_MSG_2: ' vul alsjeblieft alle verplichte in om verder te gaan.',
  EVENT_DEL_AGENDA_ITEM:
    'Weet u zeker dat u het gekozen agenda item wilt verwijderen?',
  EVENT_DEL_MESSAGE: 'Weet u zeker dat u het gekozen bericht wilt verwijderen?',
  DELIVERY_PARTNER: 'Bezorgpartner',
  DELIVERY_IMPROVEMENT_1: 'Jou producten ter waarde van: ',
  DELIVERY_IMPROVEMENT_2:
    'kunnen gratis bezorgd worden bij een bestelwaarde van: ',

  /// / Event info buttons on the event wizard
  // Event detail screen
  EVENT_FORAGE_MESSAGE:
    'Dit product heeft een leeftijdsgrens van (age)+. Kunt u bevestigen dat u de juiste leeftijd heeft.',
  EVENT_DELIVERY_OR_TAKEAWAY:
    'Als het mogelijk is, maak een keuze of u het product bezorgd wilt hebben of dat u het zelf ophaalt.',
  EVENT_NAME_INFO:
    "De 'Naam van event' is de naam van het event. De event naam zal zichtbaar zijn voor klanten in het kalender overzicht.",
  EVENT_TYPE_INFO: "De 'Type van event' is de type van het event.",
  EVENT_TW_INFO:
    "Het 'Tijdvenster' van een event is dan wel 'Fixed', anders 'Repetitive'. Als een event meermaals per dag voorkomt, kies dan voor 'Repetitive. In elk ander geval kies dan voor 'Fixed'.",
  EVENT_LOC_INFO:
    "De 'Locatie' is de locatie waar het event plaatsvindt. Ook de locatie zal voor de klant zichtbaar zijn in het kalender overzicht.",
  EVENT_PARTOF_INFO:
    'Een event kan goed passen bij meerder themas binnen het systeem. Als dit het geval is, klik dan het gekozen thema aan.',
  EVENT_CAP_INFO: "De 'capaciteit' is de maximum capaciteit van een event.",
  EVENT_BUDGET_INFO:
    "Het 'Budget' is het budget voor een event hoevaak deze als een suggestie naar de klant toe wordt gecommuniceerd gebaseerd op de 'Rate Price' van het event.",
  EVENT_LEAD_INFO:
    "De 'Lead-tijd' van een event is de lead time in minuten voor een event(standaard waarde is 0).",
  EVENT_COOL_INFO:
    "De 'Cooldown-Tijd' van een event is de cooldown time in minuten voor een event(standaard waarde is 0).",
  DURATION_INFO:
    "De 'Tijdsduur' van een event is de tijdsduur in minuten voor een event(standaard waarde is 60).",
  EVENT_DESC_INFO:
    "De 'Omschrijving' van een event is een korte introductie van het event. De omschrijving van een event zal zichtbaar zijn voor de klant.",
  EVENT_PIC_INFO:
    "De 'Afbeelding' van een event zal zichtbaar zijn voor klanten op zowel het kalendar overzicht als het event overzicht.",
  EVENT_YT_LINK_INFO:
    'De youtube link is de link die de gebruiker linkt naar de youtube-app of de webpagina van de URL.',
  // Event agenda screen
  EVENT_BG_TYPE_INFO:
    "Kies voor beschikbaarheid: 'Specific' als het event op specifieke dagen of dag valt, en kies voor 'Repeating' als het agenda item zichzelf herhaalt op 1 of meerdere dagen per week.",
  EVENT_DATES_SEL_INFO:
    "De 'Selectie van dagen' zijn de data waarop het agenda item plaatsvindt. Meerdere dagen als keuze zijn mogelijk.",
  EVENT_DAYS_SEL_INFO:
    "De 'Selectie van dagen' zijn het aantal dagen waarop het agenda item plaatsvindt. Meerdere dagen als keuze zijn mogelijk.",
  EVENT_START_DATE_INFO:
    "De 'Start-datum' is de start datum vanaf wanneer het agenda item plaatsvindt.",
  EVENT_END_DATE_INFO:
    "De 'Eind-datum' is de laatste datum waarin het agenda item plaatsvindt.",
  EVENT_START_TIME_INFO:
    "De 'Start-tijd' is de start tijd van het agenda item.",
  EVENT_END_TIME_INFO: "De 'Eind-tijd' is de eind tijd van het agenda item.",
  EVENT_INTERVAL_INFO:
    'De interval is de tijd (in minuten) tussen het einde van een enkele agenda item en de start van het volgende agenda item.',
  EVENT_DURATION_INFO:
    'De tijdsduur van een agenda item is de lengte (in minuten) in van een enkele agenda item welke meerdere keren per dag plaats kan vinden.',
  EVENT_MAXINFLOW_INFO:
    "De 'Maximale instroming' is het maximaal aantal mensen dat de location tegelijk kan betreden.",
  EVENT_PRICE_INFO:
    "De 'Event prijs' is de prijs wat een bezoeker moet bepalen voor het agenda item",
  EVENT_RATE_PRICE_INFO:
    "De 'Tarief prijs' is de prijs die u bereid bent om extra te betalen wanneer het agenda item als een suggestie aan de klant wordt gesuggereerd.",
  EVENT_REWARD_POINTS_INFO:
    "The 'Reward points' is the points a visitor can get when the visitor books this agenda item.",
  // Event communication screen
  EVENT_MSG_TITLE_INFO: "De 'Bericht titel' is de titel van het bericht.",
  EVENT_MSG_TEXT_INFO: "De 'Bericht tekst' is de tekst van het bericht.",
  EVENT_MSG_RWD_LVL_INFO:
    'Elk event heeft drie beloning niveaus, klik op een niveau om specificiek naar de gebruikers van dit niveau het bericht te versturen',
  EVENT_MSG_USER_SEL_INFO:
    'Je kunt de keuze maken om een bericht te versturen naar geregistreerde gebruikers, niet-geregistreerde gebruikers of allebei.',
  EVENT_MSG_DATE_INFO:
    'Kies de datum wanneer het bericht verstuurd moet worden.',
  EVENT_MSG_TIME_INFO:
    'Kies de tijd wanneer het bericht verstuurd moet worden.',
  EVENT_MSG_COMM_TYPE_INFO:
    'Kies het platform type voor de communicatie van het te versturen bericht.',

  SELECT: 'Selecteer',
  CONTRIBUTORS: 'Contributors',
  AVAILABLE: 'Beschikbaarheid',
  STOP_ACTION: 'Wil je de actie stopzetten?',
  EMPTY_SLOT: 'slot leegmaken',
  MOVE_SLOT_FORWARD: 'Slot verplaatsen',
  TRY: 'Test',
  DISTRIBUTION_IN_TIME: 'DIT',
  DISTRIBUTION_IN_TIME_BIG: 'Distributie in tijd',
  DISTRIBUTION_IN_PLACE: 'DIP',
  DISTRIBUTION_IN_PLACE_BIG: 'Distributie in plaats',
  CONFIRM: 'Bevestigen',
  TOTAL_ARRIVALS: 'Totale aankomsten',
  EVENT: 'Event',
  LOCATION_OVERVIEW: 'Locatie overzicht',
  EVENT_OVERVIEW: 'Events overzicht',
  STATISTICS: 'Statistieken',
  LOCATIONS: 'Locaties',
  CREATE_TOUR: 'Maak een tour aan',
  CONFIGURE_ROUTE: 'Configureer route',
  SHOW_ROUTE: 'Toon route',
  SHOW_WAYPOINTS: 'toon waypoints',
  OP_SCREEN: 'Operationeel scherm',
  SENSOR_NAME: 'Naam van sensor',
  DRIP_OBJECT_NAME: 'Naam van DRIP',
  DRIP_OBJECT_DESCRIPTION: 'beschrijving van DRIP',
  DRIP_LOCATION: 'Right click op de kaart voor de locatie van de DRIP',
  DRIP_IPADDRESS: 'IP adres van DRIP',
  DRIP_PORT: 'Poort nummer van DRIP',
  DRIP_WINDOWNAME: 'Venster naam van DRIP',
  DRIP_HEIGHT: 'Hoogte van DRIP',
  DRIP_BREADTH: 'Breedte van DRIP',
  ACCOUNT_TITLE: 'Account',
  DASHBOARD_TITLE: 'Dashboard',
  ORDERS: 'Bestellingen',
  ACCOUNT_URL: 'Website URL',
  ACCOUNT_EMAIL: 'Email adres administrator',
  ACCOUNT_TITLE_AUTOCOMPLETE: 'Naam organisatie',
  ACCOUNT_TITLE_CREATE_STYLE: 'Creeer jouw eigen stijl',
  ACCOUNT_URL_AUTOCOMPLETE: 'Website URL',
  ACCOUNT_EMAIL_AUTOCOMPLETE: 'Email adres administrator',
  ACCOUNT_CONFIRMATION: 'Account bevestiging',
  ACCOUNT_SELECTION_CONFIRMATION:
    'Weet je zeker dat je de ingevoerde data wilt opslaan op jouw account?',
  ACCOUNT_CHANGES_LATER: 'Dit kun je later ook nog aanpassen',
  ACCOUNT_LINK: 'Link',
  ACCOUNT_MAIN_LOCATION: 'Hoofdlocatie',
  ACCOUNT_ADMIN_NUMBER_SALE: 'Administratienummer verkoop',
  ACCOUNT_ADMIN_NUMBER_FEE: 'Administratiekosten',
  ACCOUNT_SERVICE_PERCENTAGE: 'Servicepercentage',
  ACCOUNT_MAX_PREBOOKS: 'Max Prebooks',
  ACCOUNT_HIGH_VAT: 'Hoog VAT',
  ACCOUNT_LOW_VAT: 'Laag VAT',
  'ACCOUNT_SALES_&_FEES': 'Instellingen voor verkoop en kosten voor',
  ACCOUNT_BOOKNUMBER_FEE: 'Boeknummer vergoedingen',
  ACCOUNT_JOURNAL_NUMBER_SALES: 'Journaalnummer Verkoop',
  ACCOUNT_JOURNAL_NUMBER_FEES: 'Journaalnummer Vergoedingen',
  ACCOUNT_NAME_OF_FILE: 'Naam van het bestand',
  ACCOUNT_MONTHLY_FEE_GENERATION_DAY: 'Dag van de maandelijkse vergoeding',
  ACCOUNT_GENERATION_DAY: 'Generatiedag',
  ACCOUNT_SAVE_SALES_FEE:
    'Sla eerst de instellingen voor verkoop en kosten op voordat u op elk van de onderstaande knoppen klikt.',
  ACCOUNT_BOTH_BUTTONS: 'Beide knoppen worden op account aangeroepen',
  ACCOUNT_GENERATE_SALES_FEES: 'Genereer verkoopkosten',
  ACCOUNT_GENERATE_MONTHLY_FEES: 'Genereer maandelijkse kosten',
  ACCOUNT_USERGROUP_NAME: 'Gebruikersgroep naam',
  ACCOUNT_NEW_USERGROUP: 'Nieuwe gebruikersgroep',
  ACCOUNT_EDIT_USERGROUP: 'Bewerk gebruikersgroep',
  ACCOUNT_USER_ID: 'Gebruiker ID',
  ACCOUNT_DELETE_USER: 'Weet je zeker dat je deze gebruiker wilt verwijderen',
  ACCOUNT_VAT_NUMBER: 'VAT nummer',
  ACCOUNT_VAT_BTW: 'Partner VAT nummer (BTW)',
  ACCOUNT_CAMPAIGN_BUDGET: 'Campagne Budget',
  ACCOUNT_PARTNER_SUPPLIER_CODE: 'Partner Leverancier Code',
  ACCOUNT_SUPPLIER_CODE: 'Leverancier code',

  PRIS_OBJECT_NAME: 'Naam van PRIS',
  PRIS_OBJECT_DESCRIPTION: 'beschrijving van PRIS',
  PRIS_LOCATION: 'Right click op de kaart voor de locatie van de PRIS',
  PRIS_IPADDRESS: 'IP adres van PRIS',
  PRIS_PORT: 'Poort nummer van PRIS',
  PRIS_WINDOWNAME: 'Venster naam van PRIS',
  PRIS_HEIGHT: 'Hoogte van PRIS',
  PRIS_BREADTH: 'Breedte van PRIS',

  VRI_OBJECT_NAME: 'Naam van PRIS',
  VRI_OBJECT_DESCRIPTION: 'beschrijving van PRIS',
  VRI_WEBSITE: 'Website',
  VRI_IP: 'IP adres',
  VRI_IVERA: 'Ivera',
  VRI_IVERA_NAME: 'Ivera naam',
  VRI_PASSWORD: 'Ivera wachtwoord',
  VRI_ITS: 'ITS Naam',
  VRI_ITS_PASSWORD: 'ITS wachtwoord',
  VRI_TRIGGER_CERT: 'Trigger certificaat',
  VRI_CERT: 'VRI certificaat',
  VRI_TRIGGER_IP: 'Trigger ip',
  VRI_VTYPE: 'V type',
  VRI_VVERSION: 'V Versie',
  VRI_VNAME: 'V naam',
  VRI_VPASSWORD: 'V wachtwoord',
  VRI_VSOURCE: 'V Source',
  VRI_VIP: 'VIP',
  VRI_VPORT: 'V Poort',
  VRI_CAPACITY: 'Capaciteit',
  VRI_NOTES: 'Notities',
  VRI_CONFIG: 'Configureren',
  VRI_XY: 'XY',
  VRI_KPP: 'KPP',
  VRI_ATTACHMENT: 'Bijlagen',

  // Incidents
  INCIDENT_FILL_IN: 'Vul de incident data in',
  GO_INCIDENT: 'Bekijken',
  INCIDENT_TITLE: 'Incident',
  INCIDENT_TITLE_2: '',
  NO_INCIDENT: 'Geen incident',
  NO_INCIDENT_DATA: 'Geen incident data',
  EVENT_START_PLANNING: 'Plannen',
  EVENT_START_SIMULATE: 'Simulatie',
  // Incident manager
  INCIDENT_DESCRIPTION_REPORTER: 'Beschrijving van de melder',
  INCIDENT_DESCRIPTION: 'Voeg een beschrijving toe',
  INCIDENT_HAPPEND: 'Wat voor incident is er ontstaan',
  INCIDENT_ON_LOCATION: 'Op locatie',
  INCIDENT_SURROUNDING: 'In de buurt',
  INCIDENT_TYPE: 'Type incident',
  INCIDENT_LIFE_THREAT: 'Levensbedreigend?',
  INCIDENT_SITUATION: 'Levensbedreigend? ',
  INCIDENT_LOCATION:
    'True? (right click on the map where the incident happened).',
  INCIDENT_EXACT_LOCATION: 'Specificeer de locatie',
  INCIDENT_DESCRIPTION: 'Uitleg incident',
  INCIDENT_ROAD_ID: 'Wegen data',
  INCIDENT_ADRESS: 'Adres data',
  INCIDENT_YES_NO: 'Ja/Nee',
  INCIDENT_GPS: 'GPS coordinates',
  INCIDENT_STREET: 'Straat naam',
  INCIDENT_NUMMER: 'Nummer',
  INCIDENT_PLACE: 'Plaats naam',
  INCIDENT_DESCRIPTION_PLACEHOLDER:
    'Omscrijving van de precieze location voor de nood services.',
  INCIDENT_ADDITIONAL_LOCATION: 'Extra locatie',
  INCIDENT_PHOTO: 'Voeg bericht toe en een foto.',
  INCIDENT_USER: 'Naam van de melder',
  INCIDENT_PHONE: 'Mobiele nummer melder',
  INCIDENT_CLOSE: 'Sluit incident',
  INCIDENT_REMOVED: 'Incident verwijderd',
  INCIDENT_NOT_REMOVED: 'Incident niet verwijderd',
  INCIDENT_DIALOG_CLOSE: 'Weet je zeker dat je het incident wilt sluiten?',
  INCIDENT_DIALOG_EDIT: 'Wil je de wijzigingen opslaan?',
  INCIDENT_SEND: 'Verstuur',
  INCIDENT_EDIT: 'Sla de wijzigingen op',
  REPORT_INCIDENT: 'Rapporteer incident',
  OVERVIEW_INCIDENT: 'Incidenten overzicht',
  INCIDENT_PICTURE: 'Incident afbeelding',

  // Incident Type
  INC_1: 'Verkeersincident',
  INC_2: 'Rommel',
  INC_3: 'Gewonden',
  INC_4: 'Te druk',
  INC_5: 'Technisch mankement',
  INC_6: 'Verkeersongeluk',
  INC_7: 'Brand',
  INC_8: 'Verdachte situatie',

  YES: 'Ja',
  NO: 'Nee',
  DELETE: 'Verwijderen',
  YES_SEND_MSG: 'Ja - Verstuur bericht',
  SEND_MSG_TO_TS: 'Verstuur bericht naar tijdslot: ',
  ON_THE: ' op de ',
  ENTER_TITLE_MSG: 'Voer de titel van het bericht in',
  ENTER_TEXT_MSG: 'Voer de tekst van het bericht in',
  SEND_MSG_TO_TS_CHECK:
    'Weet je zeker dat je een bericht wilt versturen naar alle gebruikers van de tijdslot: ',

  COMMUNICATIONS: 'Communicatie',
  FINANCIAL: 'Financiën',
  // Graphs
  TITLE_CHART_0: 'Bezoekers',
  TITLE_CHART_1: 'Wachttijd',
  TITLE_CHART_2: 'Ingangen',
  TITLE_CHART_3: 'Incidenten',
  TITLE_CHART_4: 'Aankomstpatroon bezoekers',
  TITLE_CHART_5: 'vertrekpatroon',
  NO_DESC: 'Geen beschrijving',
  REPEAT_EVENT: 'Herhaal evenement',
  EVENT_DAYS: 'Aantal dagen',

  GO_SEND: 'Bericht',
  NO_USERS: 'Geen gebruikers gevonden',
  SELECT_SIGNALS: 'Selecteer signalen',

  GRAPH_0_LABEL_0: 'Aangekomen',
  GRAPH_0_LABEL_1: 'Verwacht',
  GRAPH_0: 'Bezoekers',
  GRAPH_0_OPT: 'Bezoekers',
  GRAPH_N_ARRIVALS: 'Aantal aankomsten',
  GRAPH_N_ARRIVALS_OPT: 'Geoptimaliseerde aantal aankomsten',
  GRAPH_N_DEPARTURE_OPT: 'Geoptimaliseerde aantal vertrekkers',
  GRAPH_N_DEPARTURE: 'Aantal vertrekkers',

  GRAPH_0: 'Totaal',
  GRAPH_1: 'Vast',
  GRAPH_2: 'Flex',
  GRAPH_3: 'Spelingk',
  GRAPH_4: 'Wachtrij lengte',
  GRAPH_5: 'Huidige',

  EVENT_GRAPH_ORDER_TYPE:
    'Het gekozen event heeft mogelijk zowel een Delivery als een TakeAway optie, selecteert u er alstublieft 1 om de grafiek van data te voorzien',
  EVENT_GRAPH_SELECT_ORDER_TYPE: 'Selecteer een order type',
  EVENT_GRAPH_DATE_PICKER:
    'Selecteer een datum om inzage te krijgen in de verwachte drukte op basis van het aantal boekingen op die dag',
  EVENT_GRAPH_DETAILS: 'Verwachte drukte',

  // error codes
  ERROR_EVENT2_01: 'Aankomsten zijn hoger dan de capiciteit van dit event',
  ERROR_EVENT2_02: 'Wachtrijlengte of wachttijd overschrijdt de drempelwaarde',

  ERROR_DESTINATION_01: 'Database connectie error',
  ERROR_DESTINATION_02: 'PushNotificationBridge connectie error',
  ERROR_DESTINATION_03:
    'Verzetten van een afsrpaak in het verleden (Niet mogelijk)',
  ERROR_DESTINATION_04:
    'Inconsistente gegevens van event (tijdsbestek waar de eindtijd gelijk of lager is dan de starttijd)',
  ERROR_DESTINATION_05:
    'Maximale capaciteit overschreden (tijdens het herinplannen van een event)',
  ERROR_DESTINATION_06:
    'No reward configured (when finalizing an event or triggering a negotiation round)',
  ERROR_DESTINATION_07: 'End time - startime bigger than the interval duration',
  ERROR_DESTINATION_08: 'Parent object is not of type destination',
  ERROR_DESTINATION_09: 'Parent object null',
  ERROR_DESTINATION_10: 'Current objecy null',
  ERROR_DESTINATION_11: 'Event set back in the past',
  ERROR_DIT_01:
    'No reward configured (when finalizing an event or triggering a negotiation round)',
  ERROR_DIS_01:
    'No reward configured (when finalizing an event or triggering a negotiation round)',
  ERROR_DIT_02: 'Dit thread is already running',
  ERROR_EVENT_01: 'Passed event id passed not correct',
  ERROR_EVENT_02: 'Passed slot id not correct',

  SELECT_LOCATION: 'Selecteer een locatie',
  SELECT_EVENT: 'Selecteer een event',
  SELECT_TIME_PERIOD: 'Selecteer een tijd periode',
  SELECT_FROM: 'Van',
  SELECT_UNTIL: 'Tot',
  SELECT_WINNER: 'Selecteer winnaar',
  BACK: 'Terug',
  COMMUNICATION_CENTER: 'Communicatie centrum',
  SAVED_COMMUNICATION: 'Opgeslagen communicatie',
  NEW_COMMUNICATION: 'Nieuwe communicatie',
  COMMUNICATION: 'Communicatie',
  TYPE: 'Type',
  DATE: 'Datum',
  TIME: 'Tijd',
  CHOOSE_MESSAGE_OPTION: 'Kies een optie',
  CHOOSE_EVENT_OPTION: 'Kies een event optie',
  CHOOSE_BATCHGROUP_OPTION: 'Kies een batchgroup optie',
  ENGAGEMENT_CAMPAIGN: 'Engagement Campagne',
  ENGAGEMENT_CAMPAIGN_SUB:
    'Gebruikt voor de promotie van de event en de catering.',
  CATERING_PROMOTION: 'Catering promotie',
  SECOND_PROMOTION: 'Tweede promotie',
  PLANBOARD: 'Planboard',
  MY_PLANBOARD: 'Mijn planboard',
  SHOW_PLANBOARD: 'planboard',

  FIRST_PROMOTION: 'Eerste promotie',
  WHOM: 'Wie',
  SEND_MESSAGE_TO: 'Verstuur bericht naar',
  WHAT: 'Wat',
  TITLE_MESSAGE: 'Bericht Titel',
  LINK_TEXT: 'Outbound link',
  TEXT_MESSAGE: 'Bericht Tekst',
  PROMOCODE: 'Promotiecode',
  ADD_FAVORITE: 'Voeg toe aan favorieten',
  FAVORITE: 'Favoriet',
  WHEN: 'Wanneer',
  NEW_MESSAGE: 'Nieuw bericht',
  SINGLE_MESSAGE: 'Enkel bericht',
  SINGLE_MESSAGE_SUB:
    'Gebruikt voor updates voor extra informatie voor uw bezoekers.',
  THE_LOTTERY: 'De Loterij',
  START_LOTTERY: 'Start de Loterij',
  INTERESTED_IN: 'Ik ben geinteresseerd in events voor',

  EDIT: 'Aanpassen',
  EDIT_MESSAGE: 'Bericht aanpassen',
  MESSAGE: 'Bericht',
  MESSAGES: 'Berichten',
  MESSAGE_TITLE_1: 'Wat voor bericht wil je versturen?',
  MESSAGE_TITLE_2:
    'Je kan kiezen voor een enkel bericht of voor engagement campagne',
  MESSAGE_TITLE_3:
    'Om een bericht te versturen zal ik eerst moeten weten naar wie dit bericht verstuurd wordt.',
  MESSAGE_TITLE_4:
    'What do you want to be send and when it should be delivered to them?',
  MESSAGE_TITLE_5:
    'Welke groep bezoekers wil je bereiken met jouw engagement campagne?',
  MESSAGE_CATEGORY: 'Bericht categorie',
  SELECT_MESSAGE_CATEGORY: 'Selecteer een bericht categorie',

  WELCOME_MESSAGE_TITLE: 'Hartelijk welkom',
  WELCOME_MESSAGE: `Welkom op je persoonlijke pagina. Hier vind je alles om je bezoek aan ${appConfig.dss.environmentName} te plannen en personaliseren. Bij Instellingen pas je eenvoudig je voorkeuren aan. We wensen je veel plezier tijdens je bezoek aan ${appConfig.dss.environmentName} `,

  INVALID_ENDDATE: 'De eind datum is eerder dan de start datum.',
  INVALID_ENDTIME: 'De eind tijd is voor de start tijd.',
  INVALID_INPUT: 'De invulvelden zijn niet correct ingevuld.',
  INVALID_WEBSITE: 'Ongeldige website',
  INVALID_EMAIL: 'Invalid email address',
  FIELD_REQUIRED: 'Veld is verplicht',
  FIELD_MAX_LENGTH_32: 'Veld lengthe kan niet meer dan 32 karakters bevatten!',
  FIELD_MAX_LENGTH_1024:
    'Veld lengte kan niet meer dan 1024 karakters bevatten!',
  FIELD_MAX_LENGTH_64: 'Veld lengthe kan niet meer dan 64 karakters bevatten!',
  FIELD_MAX_LENGTH_45: 'Veld lengthe kan niet meer dan 45 karakters bevatten!',
  FIELD_MAX_LENGTH_128:
    'Veld lengthe kan niet meer dan 128 karakters bevatten!',
  FIELD_NO_SPECIAL_CHARS:
    'Speciale karakters zijn niet toegestaan ,/"\'{}[]()#$%^&* ',
  DELETE_EVENT_NOK:
    'Je bent niet de eigenaar van het gekozen event, je kan deze niet verwijderen!',
  DELETE_EVENT: 'Weet je zeker dat je het gekozen event wilt verwijderen?',

  DELETE_USER: 'Verwijder gebruiker',
  TAGS_CATEGORIES: 'Categorieën',
  DELETE_FILTERS: 'Verwijder filters',

  // new > still to sort out
  DIRECT_BOOKING: 'Direct boeken',
  ASPECTS: 'Aspecten',
  NEW_ASPECT: 'Nieuw aspect',
  BRAND: 'Merk',
  COPY: 'kopiëren',
  REQUIRED: 'Verplicht',
  SORT: 'Sorteren',
  ACTIVE: 'Actief',
  INACTIVE: 'Inactief',
  EDIT_TRANSLATIONS: 'Wijzig vertalingen',
  EDIT_BATCHGROUPS: 'Edit batchgroups',
  CREATE_USER: 'Maak account aan',
  START_TYPING: 'Begin met typen om te zoeken',
  SQUARE_PER_PERSON: 'Minimaal aantal vierkante meter per persoon (in M2)',
  ACTIVITY: 'Activiteit',
  ADD_TO_CARD: 'Product toegevoegd aan winkelmand',
  VIEW_ORDER: 'Bestelling bekijken',
  UPDATE_YOUR_ACCOUNT: 'Wil je dat we je account updaten?',
  UPDATE_USER: 'Gebruiker bijwerken',
  HOUSE_NUMBER: 'Huisnummer',
  SELECT_TIME: 'Selecteer een tijd',
  INPUT_FIELDS_EMPTY: 'De invoervelden zijn leeg.',
  NOTHING_FILLED_IN: 'Niets ingevuld',
  RETURN_TO_MY_ACTIVITIES:
    "De bestelling is opgeslagen. u keert terug naar de pagina 'Mijn activiteiten'.",
  REDIRECT_TO_APPOINTMENTS:
    'Je wordt automatisch doorgestuurd naar je afspraken',
  REDIRECT_TO_PAYMENT: 'Je wordt automatisch doorgestuurd naar de betaalpagina',
  ORDER_RECEIVED: 'Uw bestelling is ontvangen.',
  ORDER_INFO: 'Bestel informatie ',
  ORDER_OVERVIEW: 'Besteloverzicht',
  ACTIVITY_PRICE: 'Activiteit Prijs:',
  ORDER_ID: 'Uw bestellings id:',
  YOUR_ORDER: 'Uw bestelling',
  FILL_PERSONAL_DETAILS: 'Vul uw persoonlijke gegevens in',
  CHOOSE_PRODUCTS: 'Kies uw producten',
  CHOOSE_DATE: 'Kies een datum en tijd',
  CHOOSE_DELIVERY_PICKUP_METHOD: 'Kies afhalen of bezorging',
  PICKUP_LOCATIONS: 'Afhaallocaties',
  MORE_INFO: 'Meer info',
  ARRIVAL: 'Aankomst',
  ADD_ACCOMMODATION: 'Accommodatie toevoegen',
  DAILY_ACTIVITIES: 'Uw dagelijkse activiteiten',
  DEPARTURE: 'V,ertrek',
  GENERAL: 'Algemeen',
  ADDRESS: 'Adres',
  POSTAL_CODE: 'Postcode',
  COMPANY_NAME: 'Bedrijfs naam',
  COMPANY_EMAIL: 'Bedrijfs email',
  PREFERENCES: 'Voorkeuren',
  CUSTOMERS: 'Gebruikers',
  SEARCH: 'Zoeken',
  ADD: 'Toevoegen',
  CREATE_USERGROUP: 'Maak een nieuwe usergroup aan',
  EDIT_USERGROUP: 'Wijzig gebruikers groep',
  DELETE_USERGROUP: 'Verwijder gebruikers groep',
  GROUP: 'Groep',
  USERGROUPS: 'Gebruikers groepen',
  USERGROUP_NAME: 'Gebruikers groep naam',
  SEARCH_FAILED_FIRST_PART: 'Jouw zoekopdracht voor ',
  SEARCH_FAILED_SECOND_PART: 'Leverde geen resultaten op.',
  BATCHGROUPS: 'Batchgroepen',
  PRODUCTS: 'Producten',
  VIEW_BATCHGROUP: 'Overzicht batchgroup',
  CREATE_BATCHGROUP: 'Nieuwe batchgroup aanmaken',
  DAY_MON: 'Maa',
  DAY_TUE: 'Din',
  DAY_WED: 'Woe',
  DAY_THU: 'Don',
  DAY_FRI: 'Vri',
  DAY_SAT: 'Zat',
  DAY_SUN: 'Zon',
  SELECTED_DATES: 'Gekozen datum(s)',
  START_END_DATE_EQUAL_ERROR:
    'De eind datum is gelijk aan de start datum, verander alstublieft de eind datum of de start datum om door te gaan.',
  DETAILS: 'Details',
  OWNED_BY: 'Eigendom van',
  VISIBLE_FOR: 'Zichtbaar voor',
  MAIN_EVENT: 'Hoofd event',
  EVENT_DELETION: 'Event verwijderen',
  ADD_LANGUAGE_PLUS: '+ Voeg nieuwe taal toe',
  ADD_LANGUAGE: 'Voeg nieuwe taal toe',
  LANGUAGE: 'Taal',
  DESCRIPTION: 'Omschrijving',
  ARRIVAL_TEXT_MSG: 'Aankomst tekst bericht',
  DEPARTURE_TEXT_MSG: 'Vertrek tekst bericht',
  PREV_SCREEN: 'Ga naar vorige scherm',
  DONE: 'Klaar',
  ADD_CHOICE: 'Voeg keuze toe',
  CLOSE_EDIT_WINDOW: 'Sluit bewerking scherm',
  WARNING: 'Waarschuwing',
  UNSAVED_CHANGES:
    'Er zijn nog niet opgeslagen wijzigingen! Weet je zeker dat je deze wijzigen ongedaan wilt maken.',
  EVENT_DETAILS: 'Event details',
  EVENT_INFO: 'Info',
  MESSAGE_DELETION: 'Bericht verwijderen',
  PLAY_AUDIO: 'Speel audio af',
  DELETE_AUDIO: 'Verwijder audio',
  UPLOAD_EVENT_PIC: 'Laad event foto',
  DELETE_LOGO: 'Verwijder logo',
  RESULT: 'Resultaat',
  IMAGE: 'Afbeelding',
  GO: 'Gaan',
  SEARCH_OSM: 'Zoek in OpenStreetMap',
  STREET: 'Straat',
  CITY: 'Plaats',
  COUNTRY: 'Land',
  TELEPHONE: 'Telefoon',
  OPENING_HOURS: 'Openingstijden (vb: Mo - Fr 08:00 - 17:30)',
  TRANSPORTATION: 'Transport',
  OK: 'Ok',
  MY_APPOINTMENTS: 'Mijn afspraken',
  INPUT_RELATION_NAME: 'Input relatie naam',
  MAKE_ROUTE: 'Maak route',
  SAVE_RELATION: 'Relatie opslaan',
  MIN_GROUPSIZE: 'De groep grootte moet minimaal 1 zijn',
  NO_VALID_TIME_INPUT:
    'De ingevoerde tijd is niet correct, voeg alstublieft een correcte tijd in.',
  EVENT_EDITING: 'Wijzig event',
  DELETING_EVENT: 'Verwijder event',
  NEW_EVENT: 'Nieuw event',
  EDITING: 'Bewerken van ',
  LOCATION: 'Locatie',
  EVENT_CAPACITY: 'Maximale capaciteit in aantal personen',
  LEAD_TIME: 'Lead tijd',
  COOLDOWN_TIME: 'Cooldown tijd',
  DURATION: 'tijdsduur ',
  SELECT_SUBACTIVITIES: 'Selecteer sub-activiteiten',
  SELECTED_SUBACTIVITIES: 'Geselecteerde sub-activiteiten',
  EVENT_PICTURE: 'Event afbeelding',
  CATEGORIES: 'Categorieën',
  SALE: 'ACTIE',
  AVAILABLE_OTHER_ACCOUNTS: 'Beschikbaar voor andere gebruikers',
  VISIBILITY: 'Zichtbaarheid',
  ALL_EVENTS: 'Alle events',
  NO_EVENT_AVAILABLE: 'Geen event beschikbaar',
  NAME: 'Naam',
  UPLOAD_IMAGE: 'Laad foto',
  IMAGE_SIZE_NOT_REGULAR: 'Foto grootte is abnormaal',
  IMAGE_SIZE_NOT_REGULAR_SAVE:
    'Weet u zeker dat u deze foto wilt uploaden? Op de mobiele app zullen de fotos aparte proporties hebben.',
  IMG_UPLOAD_ERR: 'Er ging iets mis tijdens het opslaan van uw foto.',
  FLIP_X: 'Draai horizontaal',
  FLIP_Y: 'Draai verticaal',
  CROP_EXPL:
    'Voordat u uw foto toevoegd, kunt u uw foto hier wijzigen naar wens.',
  UPLOAD_VIDEO: 'Upload een video',
  DELETE_VIDEO: 'Verwijder de video',
  FILE_SIZE_EXCEED_MAX: 'Bestandsgrootte mag niet groter zijn dan %s MB',
  UPLOAD_FILE_FAILED:
    'Kan het bestand niet uploaden. Probeer het later opnieuw.',
  VIDEO_NOT_SUPPORT: 'Uw browser ondersteunt geen ingesloten video',
  USER_NOT_LOGGED_IN_TO_RETRIEVE_PAYMENTS:
    'Om betalings informatie op te vragen zul je ingelogd moeten zijn, log alstublieft in en probeer het nogmaals!',
  GROUP_SIZE: 'Groep grootte',
  QUANTITY: 'Aantal',
  TOTAL: 'Totaal',
  SUBTOTAL: 'Subtotaal',
  ADD_TAGS: 'Voeg tags toe',
  TOTAL_INCIDENTS: 'Totale incidenten',
  ADD_INCIDENT: 'Voeg incident toe',
  VIEW_DETAILS: 'Bekijk details',
  SAVE_INCIDENT: 'Bewaar incident',
  SAVE_IMAGE: 'Bewaar afbeelding',
  ADD_LOCATION: 'Voeg locatie toe',
  ADD_A_LOCATION: 'Voeg een locatie toe',
  EDIT_LOCATION: 'Wijzig locatie',
  DEL_LOCATION: 'Verwijder locatie',
  LINK_ACTIVATE_ACCOUNT: 'Open de link in de mail om je account te activeren.',
  WRONG_TIME_INPUT:
    'Tijdsinvoer is niet correct, vul alstublieft een geldige tijdsvoer in',
  MESSAGE_TITLE_TEXT:
    'Vul de titel en de tekst van het bericht in om door te gaan',
  ERROR_MSG_NO_PLACE_SUB_EVENT:
    'Er is geen plaats meer beschikbaar voor een gekozen sub event: ',
  ERROR_MSG_INVALID_TIME: 'Foutieve tijdsinvoer',
  ERROR_MSG_INVALID_DATE: 'Foutieve datum ingevoerd',
  ERROR_MSG_NO_ENTRY_TRANSPORT:
    'Er zijn geen plaatsen meer beschikbaar voor het gekozen type van transport. ',
  ERROR_MSG_EVENTS_RESET:
    'Uw events zijn ge-reset, selecteert u ze alstublieft nogmaals.',
  ERROR_MSG_ARRIVAL_DEPARTURE:
    'Verander alstublieft de startijd of de eindtijd.',
  WARNING_MSG_EARLY: 'Weet u zeker dat u wilt aankomen om ',
  MAIN_EVENT_START: 'Het hoofd event begint pas om  ',
  ERROR_MSG_NO_PLACE_MAIN_EVENT:
    'Er zijn geen plaatsen meer beschikbaar voor het hoofd event: ',
  ERROR_MSG_NO_PLACE_TRANSPORT_MODE:
    'Er zijn geen plaatsen meer beschikbaar voor het gekozen type van transport.',
  ERROR_MSG_NO_MAIN_BATCH_CHOSEN_TIME:
    'Geen hoofd batch in het gekozen tijdsbestek beschikbaar, selecteert u alstublieft een andere ',
  SELECT_TRIP_DAY:
    'Selecteer alstublieft een dag om informatie over je trip te bekijken',
  ENTER_SPECIAL_CODE: 'Vul je speciale code in',
  WRONG_INPUT: 'Verkeerde invoer',
  INPUT_NOT_COMPLETE: 'De input is niet compleet of goed ingevuld',
  VALID_VIP_CODE: 'Voer alstublieft een geldige VIP code in',
  MY_EVENTS: 'Mijn events',
  PART_OF: 'Onderdeel van',
  SELECTION_OF_USERS: 'Selectie van gebruikers',
  CRITERIA_BOTH: 'Geregistreerde & niet-geregistreerde gebruikers',
  CRITERIA_REG: 'Geregisteerde gebruikers',
  CRITERIA_NOT_REG: 'Niet-geregistreerde gebruikers',
  UG_FOR_USER: 'Beschikbare gebruikers groepen',
  SELECTED_UG_FOR_USER: 'Gebruiker is al geregistreerd voor: ',
  WEB_BROWSER_VERSION: 'Chrome browser versie',
  UPDATE_BROWSER_DETECTION:
    'Het systeem heeft gedecteerd dat de versie van uw chrome browser niet up-to-date is.',
  UPDATE_BROWSER_FAILS:
    'Om deze reden kunnen bepaalde functionaliteiten niet goed functioneren.',
  UPDATE_BROWSER:
    'Update alstublieft uw chrome browser naar de laatst beschikbare versie.',
  CALENDAR: 'Wat is er te doen',
  ONLY: 'Nog',
  FREE_PLACES: 'plaatsen beschikbaar',
  MINUTES: 'minuten',
  BOOK: 'Boek',
  LOCATION_PICTURE: 'Locatie afbeelding',
  UPLOAD_LOCATION_PIC: 'Laad locatie foto',
  TOGGLE_MAP: 'Kaart',
  TOGGLE_ACTIVITYLIST: 'Activiteitenlijst',

  // Partner
  PARTNER_SELECT: 'Selecteer een partner',
  PARTNER_LEVEL: 'Partner niveau',
  PARTNERS: 'Partners',
  PARTNER_DETAILS: 'Partner details',
  DELETE_PARTNER_TITLE: 'Are you sure to delete the Partner?',
  PARTNER_NAME: 'Partner name',
  PARTNER_ADDRESS: 'Partner address',
  PARTNER_CITY: 'Partner city',
  PARTNER_EMAIL: 'Partner email',
  PARTNER_POSTAL_CODE: 'Partner postal code',
  PARTNER_IBAN: 'Partner IBAN',
  PARTNER_TYPE: 'Partner type',
  SERVICE_PRICE: 'Service price',
  SERVICE_PRICE_PERCENTAGE: 'Service prijs percentage',
  SERVICE_MINIMUM_PRICE: 'Minimum service prijs',
  PLANNING_CONTRACT: 'Planning contract',
  PAYMENT_CONTRACT: 'Payment contract',
  PAYMENT_PLATFORM: 'Payment platform',
  CREATE_PARTNER: 'Maak partner aan',
  TERMS_ACCEPT: 'Ik accepteer de',
  DIRECT_DEBIT: 'Ik accepteer de automatische incasso',
  ACTIVE_PARTNER: 'Activeer partner',
  MIN_MONTHLY_FEE: "Minimale 'monthly fee'",

  PAYMENT_SUCCESS: 'Betaling gelukt',
  PAYMENT_FAILED: 'Betaling mislukt',
  TO_APP_USERS:
    'Als u een app gebruiker bent, keer alstublieft terug naar de app om terug te gaan!',

  // Empty slots
  EMPTY_SLOTS_TITLE: 'Are you sure to empty these slots?',

  // Suggestions
  SUGGESTIONS_SELECTED: 'Geselecteerde suggesties',
  SUGGESTIONS_SELECT: 'Selecteer suggesties',
  SUGGESTIONS: 'Suggesties',
  SUGGESTIONS_NO_PLACES:
    'De suggestie heeft geen plekken beschikbaar. U kunt een andere suggestie boeken.',
  SUGGESTION_BOOK_FAILED: 'Boek suggestie niet mogelijk',
  NO_SUGGESTIONS_FOUND: 'Geen suggesties gevonden',
  NO_SUGGESTIONS: 'Er zijn geen suggesties gevonden',
  NO_CAPACITY: 'Geen capaciteit',
  LIST_OF_SUGGESTIONS: 'Lijst met de suggesties',
  ADD_SUGGESTION: 'Voeg suggestie toe',
  ADD_SUGGESTION_ACCEPT:
    'Weet u zeker dat u deze suggestie wilt toevoegen aan uw bestelling?',
  CANCEL_YOUR_ORDER: 'Annuleer bestelling',
  CANCEL_YOUR_ORDER_ACCEPT: 'Bent u zeker dat u uw bestelling wilt annuleren?',
  REMOVE_SUGGESTION: 'Verwijder suggestie',
  REMOVE_SUGGESTION_ACCEPT:
    'Bent u zeker dat u deze suggestie wilt verwijderen?',
  NO_IM_NOT: 'Nee dat ben ik niet',
  YES_I_AM: 'Ja dat ben ik',
  SUGGESTION_MAKE_CHOICE: 'Maak een keuze',
  SUGGESTION_DRINKING: 'Ik wil iets drinken',
  SUGGESTION_EATING: 'Ik wil iets eten',
  SUGGESTIONS_CLICK_HERE: 'Klik hier',
  ORDER_ALL_PRODUCT_SUGGESTIONS: 'Voeg alle producten toe',
  FAILED_PRODUCTS_CAPACITY_ERROR:
    'Onderstaande producten zijn niet op voorraad en niet aan je winkelwagen toegevoegd',
  FAILED_PRODUCTS_ALREADY_IN_CART:
    'Onderstaande producten zitten al in je winkelwagen en niet opnieuw toegevoegd',
  ORDER_ALL_PRODUCT_SUGGESTIONS_FAILED:
    'Het is niet gelukt om producten aan uw winkelwagen toe te voegen. Probeer het later opnieuw.',
  JOIN_QUIZ: 'Meedoen',

  // Calendar
  CALENDAR_EVENT_STARTTIME: 'Start tijd',
  CALENDAR_EVENT_ENDTIME: 'Eind tijd',
  CALANDER_NAME: 'Agenda',
  CALENDAR_NO_ITEMS: 'Er zijn geen kalender items voor de geselecteerde dagen.',

  // Statistics
  GET_STATISTICS: 'Get statistics',
  STATISTICS_OF_TRIPS: 'Statistieken van Trips',
  STATISTICS_OF_SUGGESTIONS: 'Statistieken van suggesties',
  STATISTICS_OF_DIRECT_BOOKING: 'Statistieken van directe boekingen',
  STATISTICS_OF_PARTNERS: 'Statistieken van de partners',
  STATISTICS_OF_USERS: 'Statistieken van gebruikers',
  STATISTICS_SELECT_THE_DATES: 'Selecteer de data',
  STATISTICS_SELECT_THE_PARTNER: 'Selecteer de partner',

  // Activity details screen
  CHOOSE_A_LOCATION: 'Kies een locatie',
  CHOICES: 'Keuzes',
  READ_MORE: 'Lees meer',
  READ_LESS: 'Lees minder',
  DELIVERY_FEE: 'Bezorgkosten',
  OPTIONS_EXTRA_FEE: 'Extra kosten voor gekozen opties',
  MORE_PRODUCTS: 'meer producten',
  OR_ORDER_FOR: 'Of bestel voor',
  SELECT_THIS: 'Als u deze selecteert, moet u betalen',
  CONFIRM_YOUR_CHOICES: 'Controleer uw keuze',
  CONFIRM_YOUR_CHOICES_EXPLANATION: 'Controleer uw keuzes en druk op afronden.',
  PERSONAL_DETAILS_EXPLANATION:
    'Vul uw noodzakelijke persoonsgegevens in en laat desgewenst een opmerking achter voor speciale verzoeken.',
  ENTER_YOUR_PERSONAL_DETAILS: 'Vul uw gegevens in',
  CHOOSE_AN_OPTION: 'Bijkomende kosten en opties',
  CLICK_TO_OPEN: 'Klik om te openen',
  STARTING_AT: 'Vanaf',
  AND: 'en',
  SELECTED_DATA_EXPLANATION:
    'Kies een datum of periode en eventueel een start- en eindtijd indien van toepassing.',
  SHOWING_OPTION:
    'Geef het aantal personen aan van de gewenste mogelijkheid of ticket.',
  PRODUCT_BELOW_EXPLANATION:
    'Hieronder vind je de producten. Voeg de producten die je wilt toe en druk daarna op bestel nu.',
  BOOKING_FLOW_EXPLANATION:
    'U bent nu in het boekingsproces vul de volgende velden in om verder te kunnen.',
  EXPLAINING_COLOR_CHIPS:
    'De kleurtjes hieronder geven aan hoe druk het in bepaalde tijdsloten is',
  NO_PRODUCTS: 'Er zijn geen producten in je winkelmand',
  NO_DAYS_AVAILABLE: 'Geen dagen beschikbaar',
  NO_BOOKINGS_YET: 'Er is nog niks geboekt',
  ITEMS: 'Artikelen',
  ADD_ITEMS: 'Voeg artikel toe',
  PRE_EVENT_NOTIFICATIONS: 'Activeer pre-event notificaties',
  PRE_EVENT_NOTIFICATIONS_EXPLANATION:
    'Als je dit selecteert, ontvang je een paar minuten voordat het evenement begint een bericht.',
  NO_ENDTIMES:
    'Kan geen eind tijden krijgen met de gekozen start tijd, kies alstublieft een andere start tijd.',
  CANT_FIND_STARTIME: 'Kan geen start tijd vinden met de gekozen start datum',
  CANT_FIND_ENDDATE: 'Kan geen eind datum vinden met de gekozen start tijd',
  CANT_FIND_ENDTIME: 'Kan geen eind tijd vinden met de gekozen eind datum',
  CHOSEN_DETAILS: 'Gekozen details',
  STARTDATE: 'Start datum',
  ENDDATE: 'Eind datum',
  ACCEPT: 'Accepteer',
  AMOUNT: 'Hoeveelheid',
  AMOUNT_OF_PRODUCTS: 'Aantal stuks',
  AVA_DAYS: 'Beschikbare dagen',
  TIMES: 'Tijden',
  OPEN_HOURS: 'Openingstijden',
  HOURS: 'uur',
  PRICE: 'Prijs vanaf',
  PRICE2: 'Prijs',
  CONTACT: 'Contact',
  PHONE_NR: 'Telefoonnummer',
  PHONE_NR_REQUIRED: 'Telefoonnummer (verplicht)',
  REQUEST_CLIENT1: 'Kies een tijd',
  REQUEST_CLIENT2: 'Kies een aantal tickets.',
  OPENED_AT: 'Geopend om',
  CLOSED_AT: 'Gesloten om',
  SAVE_DETAILS:
    'Sla de persoonsgegevens op in mijn account voor volgende boekingen of bestellingen',
  NO_PLACE: 'Geen plek',
  NO_PLACE_BATCH: 'Geen plek in dit tijdslot kies een andere tijd',
  FREE_DELIVERY: 'Gratis verzending',
  FREE: 'Gratis',
  EX_DELIVERY_FEE: 'excl. bezorgkosten',
  USER_SELECTIONS: 'Jouw selecties',
  MONDAY: 'Maandag',
  TUESDAY: 'Dinsdag',
  WEDNESDAY: 'Woensdag',
  THURSDAY: 'Donderdag',
  FRIDAY: 'Vrijdag',
  SATURDAY: 'Zaterdag',
  SUNDAY: 'Zondag',
  PRICE_PERCENTAGE: 'Prijs percentage',
  PRICE_OVERVIEW: 'Prijs overzicht',
  PERCENTAGE_EXPLANATION:
    'Het percentage laat het percentage zien van de orginele prijs.',
  UNAVAILABLE: 'Niet verkrijgbare spullen',
  UNAVAILABLE_TEXT:
    'Er zijn niet verkrijgbare producten. Gaat u er mee akkoord dat deze niet gekocht kunnen worden?',
  PLEASE_STARTDATE: 'Kies alstublieft een start datum',
  PLEASE_ENDDATE: 'Kies alstublieft een eind datum',
  PLEASE_STARTTIME: 'Kies alstublieft een start tijd',
  PLEASE_ENDTIME: 'Kies alstublieft een eind tijd',
  CROWDED: 'Druk',
  UNCROWDED: 'Rustig',
  NORMAL: 'Normaal',
  BOOKED: 'Geboekt',
  OUT_OF_STOCK: 'Dit product is niet op voorraad',
  AVAILABLE_PRICES: 'Beschikbare prijzen',
  PRODUCT_INFO: 'Product informatie',
  PRICE_STARTING_AT: 'Prijs vanaf',
  NOT_AVAILABLE: 'Niet beschikbaar',
  ALMOST_FULL: 'Bijna vol',
  NOT_BUSY: 'Niet druk',
  SELECT_ORDERTYPE: 'Selecteer het type bestelling',
  REMARK: 'Opmerkingen',
  REMARK_OPTIONAL: 'Opmerkingen (optioneel)',
  DELIVERY_DISTANCE: 'Bezorg afstand',

  REGISTER_PAGE_TEXT:
    'Om jouw persoonlijke accountName paspoort aan te maken, hebben we alleen je e-mailadres nodig. Je mailadres wordt ook gebruikt om je bevestigingen en tickets te sturen als je boekingen doet. ',
  REGISTER_EMAIL_USAGE:
    'Maak een account aan om snel en eenvoudig te bestellen, te sparen voor mooie kortingen en eenvoudig bestellingen te herhalen.',
  REGISTER_PAGE_WELCOME:
    'Om uw account aan te maken, hebben we alleen uw e-mailadres nodig. Uw e-mailadres wordt ook gebruikt om u boekingsbevestigingen en tickets te sturen wanneer u activiteiten boekt.',
  LOGIN_PERSONAL:
    'Login op je persoonlijke accountName paspoort. Heb je nog geen paspoort? Registreer om er binnen een minuut eentje aan te maken. Met jouw accountName paspoort kan je makkelijk je bezoek plannen en boeken, favorieten bewaren en leuke kortingen krijgen voor jouw bezoek aan accountName ',

  // Coupon code order
  DETAILS_FROM_RECIPIENT: 'Geef een cadeaubon weg',
  RECIPIENT_MESSAGE: 'Boodschap voor de ontvanger',
  RECIPIENT_FIRSTNAME: 'Voornaam van de ontvanger',
  RECIPIENT_LASTNAME: 'Achternaam van de ontvanger',
  RECIPIENT_EMAIL: 'Email van de ontvanger',
  RECIPIENT_DETAILS_DESCRIPTION:
    'Je kunt de cadeaubon ook weggeven.<br>Indien je hier een e-mail, naam en een persoonlijke boodschap voor de ontvanger invult zullen wij hem deze direct mailen.<br>Als je de coupon zelf wilt gebruiken of op een andere manier weg wilt geven kun je deze velden leeg laten.<br>U zult altijd zelf een kopie van de cadeaubon toegestuurt krijgen ter controle.',

  // orders
  ORDER: 'Selecteer event',
  ORDER_LIST_EMPTY: 'Lijst is leeg',
  ORDER_NO_ORDERS: 'Geen bestellingen',
  ORDER_NO_ORDERS_FOUND: 'Er zijn geen bestellingen gevonden',
  ORDER_DOWNLOAD: 'Download',
  ORDER_NR: 'Bestelling nr',
  ORDER_TYPE: 'Bestelling type',
  ORDER_NOW: 'Bestel nu',
  ORDER_DETAILS: 'Bestelling details',
  ORDER_COMPLETED: 'Bestelling voltooid',
  ORDER_COMPLETED_DEFAULT:
    'Bedankt voor je bestelling. Uw bestelling is succesvol aangemaakt.',
  ORDER_COMPLETED_DEBIT:
    'Uw betaling wordt afgehandeld via automatische incasso.',
  ORDER_COMPLETED_INVOICE:
    'U ontvangt de factuur per e-mail. Gelieve de factuur vóór de vervaldatum te betalen.',
  ORDER_THANKS: 'Bedankt voor je bestelling.',
  ORDER_VIEW_BELOW:
    ' kunt uw activiteit bekijken door op de onderstaande knop te klikken.',
  ORDER_COUPON_CODE: 'Kortingscode',
  ORDER_CHECK_COUPON_CODE: 'Controleer kortingscode',
  COUPON_NOT_APPLIED_TITLE: 'Voeg je kortingscode toe',
  COUPON_NOT_APPLIED_MESSAGE:
    'Kortingscode is ingevuld maar nog niet toegevoegd aan uw bestelling. Wil je deze nu toevoegen?',
  ORDER_WAIT_FOR_PARTNER_CONFIRMATION:
    'Uw boekingsaanvraag is ter bevestiging doorgestuurd naar onze partner. U ontvangt een bericht wanneer de partner uw boekingsaanvraag heeft bevestigd of afgewezen.',
  CANCEL_ORDER_GROUP_SUCCESS: 'Uw bestelling is succesvol geannuleerd.',
  CANCEL_ORDER_GROUP_ERROR:
    'Kan uw bestelling niet annuleren. Probeer het later opnieuw.',

  // Error codes
  E_00_00: 'Er is iets misgegaan, probeert u het alstublieft later nogmaals',
  E_PO_010:
    'De verschillende tijdspanne voor de activiteit zijn op het moment niet beschikbaar, probeert u het alstublieft later nogmaals',
  E_PO_011:
    'Het was niet mogelijk om een ​​activiteit aan het planbord toe te voegen. Controleer je planbord en probeer een andere datum of tijd.',
  E_PO_012:
    'Het was niet mogelijk om een activiteit toe te voegen aan jouw Planboard, probeert u het alstublieft later nogmaals',
  E_PO_013:
    'De gekozen tijdspanne heeft geen capaciteit,Probeer een ander tijdspanne te kiezen indien beschikbaar',
  E_PO_014:
    'Het was niet mogelijk om de gekozen activiteit te wijzigen in jouw Planboard',
  E_PO_015:
    "Het is niet toegestaan om de gekozen activiteit te wijzigen, omdat de betaalstatus hiervan nog niet op 'betaald' staat",
  E_PO_016:
    'De gekozen tijdspanne zit in een andere tijdspanne-groep, selecteer alstublieft een andere tijd',
  E_BK_001:
    'Helaas is het te druk op de locatie van het event, probeert u alstublieft de aankomst-tijd en/of de vertrek-tijd aan te passen.',
  E_BK_002:
    'Geen van de producten die u gekozen heeft zijn beschikbaar, kies alstublieft een andere datum/tijd of kies een ander product.',
  E_PC_003:
    'Het is niet mogelijk om de gekozen prijs categorie te verwijderen, omdat deze al gelinkt is aan een tijdslot.',
  E_CP_001: 'Geen aankomst capaciteit beschikbaar',
  E_CP_002: 'Geen vertrek capaciteit beschikbaar',
  E_CP_003: 'Geen event capaciteit beschikbaar',
  E_CP_004: 'De batch kon niet gevonden worden',
  E_CP_005: 'Geen product capaciteit beschikbaar',
  E_OB_002:
    'Er is iets mis gegaan met het opstarten van het gekozen event, probeert u het alstublieft later nogmaals',
  E_UG_002: 'De order behoort niet tot de huidige partner',
  E_UG_003: 'De order is al gebruikt',
  E_UG_004: 'De ticket(s) binnen de order zijn niet bevestigt',
  E_MPID_001: 'De betalings-ID is niet gevonden',

  E_ROUTE_001: 'Geen capaciteit',
  E_ROUTE_002:
    'Er waren geen bestellingen in de database voor de gegeven invoer',
  E_ROUTE_003:
    'Route generator heeft geen oplossing gevonden binnen de gegeven tijd',
  E_ROUTE_004: 'Er is geen oplossing voor het gegeven routing probleem',
  E_ROUTE_005: 'Route generator niet correct geconfigureerd',
  E_ROUTE_006: 'Geen route gevonden, Probeer een ander transport type.',

  E_GSD_001: 'Er zijn geen start data',
  E_GSD_002: 'Er zijn geen eind data',
  E_GSD_003: 'Er zijn geen start tijden',
  E_GSD_004: 'Er zijn geen eind tijden',
  E_RA_001:
    'Het ophalen van de event gegevens is mislukt, probeer het later nogmaals.',
  E_RA_002:
    'Het ophalen van de Route aspect data is mislukt, probeer het later nogmaals.',
  E_RA_003:
    'De opgehaalde route-aspect data is niet voor het correcte event, probeer het later nogmaals.',
  E_RA_004:
    'Het ophalen van de route-punten binnen de route aspect data is mislukt, probeer het later nogmaals.',

  E_OM_001: 'De order-ID is incorrect.',
  E_OM_002: 'De confirmation-ID hoort niet bij het order-ID.',
  E_OM_003: 'De order is reeds al geaccepteerd/afgewezen.',

  // Back-End Failure
  W_BEF_001:
    'De ontvangen gegevens zijn niet volledig, probeer het later opnieuw. ',
  W_BEF_002:
    'De server is momenteel offline, SuperLinda en haar team werken er hard aan om het op te lossen. ',

  // CouponCode
  E_GV_001: 'U heeft deze kortingscode al gebruikt.',
  E_GV_002: 'Deze kortingscode is ongeldig.',
  E_GV_004:
    'Deze kortingscode kan alleen worden gebruikt door bepaalde gebruikersklassen.',
  E_GV_005: 'Ongeldige couponcode. De coupon is verlopen.',

  // GetAccountInfo
  W_GAI_001: 'De accountgegevens zijn niet volledig, probeer het opnieuw. ',

  // GetUserData
  W_GUD_001: 'De gebruikersgegevens zijn niet volledig, probeer het opnieuw. ',
  W_GUD_002:
    'we hebben de gebruikersgegevens niet kunnen ontvangen. Probeer het opnieuw. ',

  // GetEventDetails
  W_GED_001: 'Het laden van de event-foto is mislukt. Probeer het opnieuw. ',
  W_GED_002:
    'Het laden van de event-beschrijving is mislukt. Probeer het opnieuw. ',
  W_GED_003: 'Het laden van de event-ID is mislukt. Probeer het opnieuw. ',
  W_GED_004:
    'Het laden van de event gegevens is mislukt. Probeer het opnieuw. ',

  // GetCalendar
  W_GC_001: 'Het laden van de agenda is mislukt. Probeer het opnieuw. ',

  // GetTourActivities
  W_GTA_001:
    'Het ophalen van de tour activiteiten is mislukt. Probeer het opnieuw. ',

  // GetThemes
  W_GT_001:
    "Het laden van de thema's voor het huidige account is mislukt. Probeer het opnieuw. ",

  // GetChildrenEvents
  W_GCE_001:
    'Het laden van de evenementen van het geselecteerde thema is mislukt. Probeer het opnieuw. ',

  // GetFavourites
  W_GF_001: 'Het laden van je favorieten is mislukt. Probeer het opnieuw. ',

  // Add/Delete Favourite
  W_ADF_001:
    'Het toevoegen/verwijderen van een nieuwe favoriet is mislukt. Probeer het opnieuw. ',

  // GetEventsForLocation
  W_GEFL_001:
    'Het ophalen van de events voor de locatie is mislukt. Probeer het opnieuw. ',

  // GetLocationDetails
  W_GLD_001:
    'Het ophalen van de locatie gegevens is mislukt. Probeer het opnieuw. ',

  // GetEventsBasedOnUserLevel
  W_GEBOU_001: 'Het laden van de evenementen is mislukt. Probeer het opnieuw. ',

  // GetLocations
  W_GL_001: 'Het laden van de locaties is mislukt, probeer het opnieuw. ',

  // DeleteEvent
  W_DE_001:
    'Er is iets misgegaan bij het verwijderen van het event. Probeer het opnieuw. ',

  // GetPostOfEvent
  W_GPOE_001: 'Het laden van de event poster is mislukt. Probeer het opnieuw. ',

  // GetAccounts
  W_GA_001: 'Het laden van de accounts is mislukt. Probeer het opnieuw.  ',

  // SaveEvent
  W_SE_001: 'Het opslaan van het event is mislukt. Probeer het later opnieuw. ',

  // ActivateAccount
  W_AA_001:
    'Er was geen token ontvangen bij het activeren van de account, pProbeer het opnieuw. ',
  W_AA_002: 'Het activeren de account is mislukt, Probeer het opnieuw. ',

  // CreateAccount
  W_CA_001:
    'Email adres kan niet confirmed worden, er is geen email ontvangen. Probeer het opnieuw. ',
  W_CA_002: 'Het aanmaken van de account is mislukt, probeer het opnieuw. ',

  // UpdateAccount
  W_UA_001: 'Het updaten van de account is mislukt, probeer het opnieuw. ',

  // GetExactCsvs
  W_GEC_001: 'Het laden van exact-bestanden is mislukt, probeer het opnieuw. ',

  // GenerateSalesFees
  W_GSF_001: 'Het genereren van Sales & Fees is mislukt, probeer het opnieuw. ',

  // GenerateMonthlyFees
  W_GMF_001:
    'Het genereren van de Monthly Fees is mislukt, probeer het opnieuw. ',

  // GetSalesFeesPref
  W_GSFP_001: 'Er is geen start datum ontvangen, probeer het opnieuw. ',
  W_GSFP_002: 'Er is geen eind datum ontvangen, probeer het opnieuw. ',
  W_GSFP_003: 'Er is geen Generation Date ontvangen, probeer het opnieuw. ',
  W_GSFP_004:
    'Het laden van de Sales en Fees voorkeuren zijn mislukt, probeer het opnieuw. ',

  // SetSalesFeesPref
  W_SSFP_001:
    'Het opslaan van de Sales en Fees voorkeuren zijn mislukt, probeer het opnieuw. ',

  // Standard Contact Helpdesk
  W_HELPDESK_001:
    'Als dit probleem zich blijft voordoen, neem dan contact op met de helpdesk van SuperLinda.',

  // Book
  NOT_CHOSEN: 'U heeft nog niks gekozen.',

  // Shopping cart
  SHOPPINGCART_NOT_EMPTY_DESCRIPTION:
    'Er zitten nog producten in je winkelwagen. Als je uitlogt zullen deze producten ook verwijdert worden uit de winkelwagen.',
  SHOPPINGCART_SURE_ABOUT_LOGGING_OUT: 'Weet je zeker dat je wilt uitloggen?',
  SHOPPINGCART_NOT_EMPTY: 'Je winkelwagen is niet leeg ',
  SHOPPINGCART: 'Winkelwagen',
  ADD_REQUEST: 'Voeg een verzoek toe',
  REQUEST: 'Verzoek',
  SHOPPINGCART_EMPTY: 'Uw winkelwagen is leeg',
  CARTITEM_REMOVED: 'Item is verwijderd uit winkelmand',
  CARTITEM_NOT_REMOVED:
    'Item is niet verwijderd uit winkelman, probeer het opnieuw',
  FAILED_ADD_CART:
    'Het toevoegen van uw product(en) aan uw winkelwagen is mislukt, probeer het opnieuw',
  FAILED_ADD_SHOPPINGLIST:
    'Het toevoegen van uw product(en) aan uw winkel lijst is mislukt, probeer het opnieuw',
  ADD_CART: 'Uw product (en) zijn toegevoegd aan uw winkelwagen',

  TICKETS_RESERVED: 'Uw ticket (s) zijn gereserveerd',
  TICKETS_FAIL_RESERVED:
    'Het boeken van uw ticket(s) is mislukt, probeer het opnieuw',
  PARTNER_DOESNT_EXIST: 'Deze partner groep bestaat niet ',
  BOOKING_FAIL: 'Het boeken van uw bestelling is mislukt, probeer het opnieuw.',

  // DeliveryRouteGenerate screen
  'TIME/DATEINFO': 'Tijd/Datum info',
  DELIVERY: 'Bezorgen',
  PICKUP: 'Ophalen',
  TRANSPORT: 'Vervoer',
  GENERATE_ROUTE: 'Route genereren',
  ADD_DELIVERY_PERSON: 'Voeg bezorger toe',
  DELIVERY_CONFIG: 'Bezorg configurator',
  DELIVERER: 'Bezorger',
  ORDERID: 'Bestelling id',
  DELIVERYNR: 'Bestelling nummer',
  NOTHING_DROPPED: 'Niks achterwege gelaten',
  DROPPED: 'Achterwege gelaten',
  LOCATION_NOT_FOUND: 'Locatie niet gevonden',
  CAR: 'Auto',
  BICYCLE: 'Fietsend',
  WALKING: 'Lopend',
  HOUR: 'Uur',
  START_CONFIGURE: 'Begin met configureren',

  // Lorenzo added new translations not in Deutsch
  UNCONFIRMED: 'Niet bevestigd',
  CONFIRMED: 'Bevestigd',
  WAITING_FOR_PAYMENT: 'wachten op betaling',
  ARRIVED: 'Aangekomen',
  FIRSTNAME: 'Voornaam',
  LASTNAME: 'Achternaam',
  PLACE_OF_RESIDENCE: 'Woonplaats',
  DATE_OF_BIRTH: 'Geboortedatum',

  USER_PROGRESS_ACTIVATION: 'Gebruiker activeren',
  USER_SUCCESS_ACTIVATED: 'De activatie van jouw account is geslaagd!',
  USER_SUCCESS_ACTIVATED_LINK: 'Heeft u uw account bij de app geregistreerd?',
  USER_SUCCESS_ACTIVATED_DOWN:
    'Ben je een web gebruiker ? We hebben ook een app beschikbaar, klik op de juiste store voor je mobiel om de app te downloaden of ga verder via het web.',
  USER_ACTIVATION_FAILED: 'De activering van uw account is mislukt',

  USER_NOT_ACTIVATED_TEXT:
    'Uw account is nog niet geactiveerd, Klik alstublieft op de activatie link in de activatie-mail die u ontvangen heeft.',
  USER_NOT_ACTIVATED_MAIL:
    'Als u de mail niet kunt vinden of u heeft de mail niet ontvangen, klik dan op de knop hieronder om de activatie-mail opnieuw te versturen naar het mail-adres: ',
  RESEND_ACTIVATION: 'Verstuur activatie-mail',
  ACTIVATION_MAIL_IS_SEND: 'De mail is verstuurd naar het mailadres: ',
  USER_FORGOT_PASSWORD:
    'Uw login details worden opnieuw verstuurd naar uw email.',
  USER_FORGOT_PASSWORD_SEND:
    'Uw inloggegevens zijn opnieuw naar uw e-mail gestuurd.',
  RESEND_LOGIN_DETAILS: 'Verstuur login details',
  FORGOT_PASS: 'Wachtwoord vergeten? ',
  USER_PASS:
    "Ga dan terug naar de app klik op 'inloggen' en log in met uw mailadres en onderstaand wachtwoord:",
  FORGOT_PASSWORD_BACK: 'Terug',
  RESET_PASS_TITLE: 'Reset je wachtwoord',
  RESET_PASS_SUBTITLE:
    'De link om je wachtwoord opnieuw in te stellen wordt naar je mailbox gestuurd',
  RESET_PASS_MAIL_SENT_TITLE:
    'De link om je wachtwoord opnieuw in te stellen is naar je mailbox gestuurd',
  CHECK_SPAM_REMINDER:
    'Controleer uw spammap voor het geval u de e-mail niet heeft ontvangen',
  OLD_PASS: 'Oud Wachtwoord',
  NEW_PASS: 'Nieuw paswoord',
  CONFIRM_NEW_PASS: 'Bevestig nieuw wachtwoord',
  PASS_NOT_MATCH:
    'Nieuw wachtwoord komt niet overeen met de bevestig wachtwoord',
  SAVE_AND_LOGIN: 'Opslaan en inloggen',
  PASS_CHANGED_DESC: 'Uw nieuwe wachtwoord is succesvol opgeslagen',
  REGISTER_PASS_NOT_MATCH:
    'Wachtwoord komt niet overeen met de bevestig wachtwoord',
  PASS_LENGTH_LIMIT: 'De lengte moet tussen 8 en 48 tekens zijn',
  CONFIRM_PASS: 'Bevestig het wachtwoord',

  EVENT_DESCRIPTION_EC: 'Event omschrijving',
  EVENT_DURATION_EC: 'Gemiddelde tijdsduur',
  EVENT_PART_OF_THEMES_EC: "Onderdeel van de thema's: ",
  EVENT_BUDGET_EC: 'Event budget',
  EVENT_REM_BUDGET_EC: 'Resterende event budget',
  EVENT_PRE_EVENT_Q_EC:
    'Pre-eventvraag (antwoord is altijd ja/nee event question (answer is always yes/no)',
  EVENT_PRE_EVENT_Q_SMALL_EC: 'Pre-eventvraag',
  EVENT_MANAGED_EC:
    'Selecteer deze optie als het event wordt beheerd door een planboard',
  EVENT_TICKET_TYPES_EC:
    'Klik op de onderstaande knop om tickets voor het event toe te voegen',
  EVENT_BOOKING_POL_EC:
    'Klik op de onderstaande knop om het boekingsbeleid voor het event toe te voegen',
  EVENT_SUG_EC:
    'Klik op de onderstaande knop om suggesties voor het event toe te voegen',
  EVENT_ALTER_EC:
    'Klik op de onderstaande knop om alternatieven voor het event toe te voegen',
  EVENT_SUB_ACT_EC:
    'Klik op de onderstaande knop om sub-activiteiten voor het event toe te voegen',

  // Partner confirmation
  PAR_CON_LEAD_P1: 'De bevestiging van de bestelling: ',
  PAR_CON_LEAD_P2: ' is ontvangen. De nieuwe bevestigde status is: ',
  PAR_CON_LEAD_P3:
    'Er is geen bevestiging ontvangen. Klik opnieuw op de link in uw e-mail om het opnieuw te proberen. ',
  PAR_CON_OR_ST_ACC: 'Geaccepteerd',
  PAR_CON_OR_ST_REJ: 'Afgewezen',
  PAR_CON_OR_ST_FAI: 'Mislukt',
  PAR_CON_ORDER: 'Order-ID: ',
  PAR_CON_CONFIRMATION: 'Confirmation-ID: ',
  PAR_CON_STATUS: 'Status: ',

  // Stock details
  CHANGE_STOCK: 'Voorraad wijzigen',
  VALID_CAPACITY: 'Voer alstublieft een geldige capaciteit in',
  STOCK_PRO_SUC_CHANGED:
    'De voorraad voor het gekozen product is met succes gewijzigd',
  STOCK_ITEM_SUC_CHANGED:
    'De voorraad voor het gekozen product-item is met succes gewijzigd',
  CONFIRM_PRODUCT_PART_1: 'Weet u zeker dat u de voorraad van het product: ',
  CONFIRM_PRODUCT_PART_2: " op 'Niet op voorraad' wilt zetten? ",
  ENTER_NEW_PRO_STOCK: 'Voer hieronder de nieuwe voorraad in voor product: ',
  CONFIRM_ITEM:
    "Weet u zeker dat u het gekozen product-item op 'Niet op voorraad' wilt zetten? ",
  ENTER_NEW_ITEM_STOCK:
    'Voer hieronder de nieuwe voorraad in voor het gekozen product-item ',

  // location
  LOCATION_SQUARE_PER_PERSON: 'Voer de min. vierkante meter per persoon',
  LOCATION_PUBLIC_TRANSPORT: 'Openbaar vervoer',
  LOCATION_MARK_LOCATION: 'Markeer locatie',
  LOCATION_BOUNDARIES: 'Grenzen',
  LOCATION_LATITUDE: 'Latitude',
  LOCATION_LONGITUDE: 'Longitude',
  LOCATION_RADIUS: 'Straal',
  LOCATION_USED_BY: 'Gebruikt door',
  LOCATION_ENTRY_POINT: 'Ingangspunt',
  LOCATION_ENTRY: 'Ingang',
  LOCATION_EXIT: 'Uitgang',
  'LOCATION_ENTRY/EXIT': 'Ingang / uitgang',
  LOCATIONS_CONTAINS: 'Locatie bevat',
  LOCATION_ARE_YOU_SURE: 'kinderen! Weet je het zeker?',

  // map
  MAP_SELECT_LOCATION: 'Selecteer een locatie met: Rechts+Klik.',
  MAP_TOUR_CONFIGURATION: 'Configuratie voor de tour',
  MAP_SELECTED_TOUR_ACTIVITIES: 'Geselecteerde reisactiviteiten',

  // Policies
  POLICIES_EXPLANATION: 'Enige uitleg over evenementenbeleid',
  POLICIES_NEW: 'Nieuw evenementenbeleid',

  // Filter
  FILTER_SELECT: 'Selecteer filters',
  FILTER_NO_SELECTED: 'Geen filters geselecteerd',
  FILTER_SELECTED: 'Geselecteerde filters',

  // Alternative
  ALTERNATIVE_SELECT: 'Kies alternatieven',

  // Reviews
  LOAD_MORE: 'Laad meer',
  REVIEWS: 'Beoordelingen',
  NEWEST_REVIEWS: 'Nieuwste beoordelingen',
  REVIEW: 'Beoordeling',
  REVIEW_WRITE: 'Schrijf een beoordeling',
  REVIEW_SUCCESS: 'Beoordeling succesvol geplaatst.',
  REVIEW_FAIL: 'Er ging iets mis tijdens het plaatsen van uw beoordeling.',
  REVIEWS_SEE_MORE: 'Zie meer',
  REVIEWS_NO_MESSAGES_YET: 'Er zijn nog geen reviews beschikbaar',
  REVIEWS_TITLE: 'Wat mensen van ons vinden',

  // HomepageBanner
  BANNER_SEARCH_EVENT_TITLE: 'Zoek het event dat bij jou past!',
  BANNER_SEARCH_EVENT_SUBTITLE:
    "Tijdens het zoeken, druk op 'enter' om het filterscherm voor events te gebruiken..",

  // HomepageThemes
  DISCOVER_THEMES: "ontdek onze thema's",

  // HomepageApp
  CHOOSE_THE_APP_REASON_1: 'Ga op avontuur met onze fantastische routes',
  CHOOSE_THE_APP_REASON_2:
    'Rapporteer incidenten om jezelf en andere te helpen',
  CHOOSE_THE_APP_REASON_3: 'Beheer uw boekingen onderweg',

  // Header
  ALL_LANGUAGES: 'Alle talen',

  // ProductInfo
  PRODUCT_WEIGHTED_ATTENTION_TEXT:
    'Dit product wordt verkocht op basis van aantal en eenheidsprijs. De exacte hoeveelheid wordt bepaald na de bestelling, dus de uiteindelijke prijs kan iets afwijken',

  // EventDetails Products
  ATTENTION: 'Attentie',
  OVERWRITE_SHOPPING_CART_ITEM:
    "Dit product bevindt zich al in uw winkelwagen. Als u op 'voeg toe aan winkelwagen' klikt, wordt dit item in uw winkelwagen overschreven.",
  ADD_TO_SHOPPING_CART: 'In winkelwagen',
  PRODUCT_INFO_TEXT:
    'Dit product wordt verkocht op basis van hoeveelheid en eenheidsprijs. De exacte hoeveelheid wordt bepaald na bestelling, dus de uiteindelijke prijs kan iets afwijken.',
  REQUEST_INFO_TEXT:
    'Uw aanvraag wordt in behandeling genomen zodra u uw bestelling heeft afgerond. U ontvangt op een later tijdstip bericht over de kosten en kunt uw bestelling betalen.',
  AVAILABLE_CATEGORIES: 'Beschikbare categorieën',
  ADD_TO_SHOPPING_LIST: 'In lijst',

  // HomepageFooter
  IOS_APP: 'iOS app',
  AND_APP: 'Android app',
  MENU: 'Menu',
  HOME: 'Startpagina',
  ABOUT_US: 'Over ons',
  ABOUT_BUYFRESH: 'Over BuyFresh',
  PARTNERS: 'Partners',
  CONTACT: 'Contact',
  NEED_HELP: 'Hulp nodig?',
  CONTACT_PAGE: 'Ga naar de contact pagina',
  VIEW_FAQ: 'Bekijk de FAQ',
  PAGE_SELECT: 'Kies een pagina',
  PARTNER: 'Partner',

  // Delivery & pickup
  DELIVERY_PICKUP: 'Bezorgen & ophalen',
  INCLUDED_AREAS: 'Wij bezorgen in de volgende gebieden: ',
  EXCLUDED_AREAS: 'Wij bezorgen niet in de volgende gebieden: ',
  NO_DELIVERY_OR_PICKUP: 'Kan geen bezorg- en ophaalevenementen krijgen ...',
  DELIVERY_STARTS_FROM: 'Minimale bestelwaarde voor bezorgen is',
  DELIVERY_NO_ENOUGH_PRODUCTS:
    'Voeg wat meer producten toe aan uw bestelling om verzending mogelijk te maken of selecteer een andere verzendmethode (price over)',

  // succes.vue
  BACK_HOME_PAGE: 'Terug naar de startpagina',
  // UserConfirmation
  ALERT_TEXT_CONFIRMED:
    'We hebben uw verzoek ontvangen, maar de bestelling is al bevestigd. Dit venster wordt automatisch gesloten',
  ALERT_TEXT_WAI_FOR_PAY_ACCEPT:
    'We hebben uw acceptatie ontvangen, u wordt automatisch doorgestuurd naar de betaalpagina.',
  ALERT_TEXT_WAI_FOR_PAY_REJECT:
    'We hebben uw afwijzing ontvangen, uw bestelling is geannuleerd. Dit venster wordt automatisch gesloten.',
  ALERT_TEXT_CANCELLED:
    'Uw bestelling is geannuleerd, er zijn geen acties mogelijk voor deze bestelling. Dit venster wordt automatisch gesloten.',
  ALERT_TEXT_DONE:
    'Je bestelling is al gedaan, er zijn geen acties mogelijk voor deze bestelling. Dit venster wordt automatisch gesloten.',
  ALERT_TEXT_PAR_CONF:
    'je hebt deze bestelling al geaccepteerd / afgewezen. De bestelling wacht op betalingsbevestiging. Geen acties mogelijk voor deze bestelling. Dit venster wordt automatisch gesloten',
  ALERT_TEXT_ERROR:
    'Er is iets misgegaan. Probeer het opnieuw. Dit venster wordt automatisch gesloten',

  // About us page
  ABOUTUS: 'Over ons',
  ABOUTUS_INFO_PART1:
    'Buy Fresh is een online samenwerkingsplatform van lokale telers, slagers, bakkers en kaasboeren. Buy Fresh is de ideale combinatie van online en een fysieke winkel.',
  ABOUTUS_INFO_PART2:
    'Buy Fresh maakt het gemakkelijk om de kwaliteit van de lokale versspecialist te kiezen. Via één webshop kunt u producten van meerdere specialisten tegelijk bestellen.',
  ABOUTUS_INFO_PART3:
    'Met Buy Fresh organiseren de specialisten eenvoudig de afhandeling van bestellingen, het opzetten van afhaalpunten of het samen bezorgen van bestellingen.',
  ABOUTUS_INFO_PART4:
    'Door slimme online samenwerking profiteren de specialisten van elkaars klanten en delen ze de kosten van afhaalpunten en bezorging, waardoor dit winstgevender wordt.',
  ABOUTUS_INFO_PART5:
    'Het gemak van de online supermarkt, met de kwaliteit van de lokale specialist. Dat is Buy Fresh.',
  ABOUTUS_INFO_PART6: 'Ook geintresseerd? mail naar ',

  // Error codes for booking flow
  E_PO_006_SUBSCRIPTION_PRODUCT:
    'Sommige producten in uw abonnement zijn niet meer beschikbaar.',
  E_PO_006_PRODUCT: 'Het gekozen product is niet meer beschikbaar.',
  E_PO_006_TICKET:
    'Het gekozen event heeft niet genoeg capaciteit. Probeer een andere tijd/datum of verander de ticket aantallen.',
  E_PO_011:
    'De boeking heeft een conflict met een eerder geplande boeking! Weet u zeker dat u verder wilt gaan ?',
  E_PO_023_ADDPRODUCT:
    'Het is niet gelukt om het product toe te voegen aan je winkelwagen, omdat de items verlopen zijn. Uw winkelwagen wordt geleegd en het gekozen product wordt toegevoegd aan uw winkelwagen.',
  E_PO_023_CHANGEPRODUCT:
    'Het is niet gelukt om het product te wijzigen, omdat de items verlopen zijn. Uw winkelwagen wordt geleegd en het gewijzigde product wordt toegevoegd aan uw winkelwagen.',
  E_PO_023_BOOKWITHRESERVATIONS:
    'Het is niet gelukt om te boeken, omdat er items verlopen zijn. Uw winkelwagen wordt geleegd. U kunt opnieuw items toevoegen aan uw winkelwagen.',
  E_PO_024_ADDPRODUCT:
    'Het is niet gelukt om het product toe te voegen, omdat het niet onderdeel is van uw order.',
  E_PO_024_CHANGEPRODUCT:
    'Het is niet gelukt om het product te wijzigen, omdat het niet onderdeel is van uw order.',
  E_PO_024_ADDSPECIALREQUEST:
    'Het is niet gelukt om de special request toe te voegen, omdat het niet onderdeel is van uw order.',
  E_DEL_007_DELIVERY_ADD_PRODUCT:
    'Het is niet gelukt om het product toe te voegen, dat is uitgesloten door de door jou geselecteerde bezorgservice. Maak een aparte bestelling voor dit product.',
  E_DEL_007_PICKUP_ADD_PRODUCT:
    'Kan het product niet toevoegen, dat niet kan worden opgehaald in de door jou geselecteerde ophaallocatie. Maak een aparte bestelling voor dit product.',
  E_SL_001:
    'Dit product heeft partner bevestiging nodig en kan daarom niet aan je bestellijst worden toegevoegd.',
  E_USR_077_ADD_TO_LIST:
    'Dit product kan niet aan uw bestellijst worden toegevoegd, omdat automatische incasso of kopen op rekening ingeschakeld moet zijn.',
  E_DEL_002:
    'Minimale bestelwaarde is niet bereikt om de producten te reserveren. Voeg meer producten toe of selecteer een andere verzendmethode.',

  // Acount
  SIGN_IN: 'Aanmelden',
  NOT_A_MEMBER: 'Geen lid?',
  BACK_TO: 'Terug naar',

  // Activities
  HISTORY: 'Geschiedenis',
  NO_UPCOMING_ACTIVITIES: 'Je hebt geen aankomende activiteiten ...',
  NO_PAST_ACTIVITIES: 'Je hebt geen eerdere activiteiten ...',
  NOTE: 'Notitie',
  GET_TICKETS: 'Krijg kaartjes',
  CANCEL_ACTIVITY: 'Activiteit annuleren',
  LEAVE_A_REVIEW: 'Laat je mening achter',
  REVIEWED: 'Beoordeeld',
  PICK_A_RATING: 'Kies een beoordeling',
  SUBMIT: 'Verzenden',
  DELETE_ACTIVITY: 'Activiteit verwijderen',
  SURE_CANCEL_ACTIVITY: 'Weet u zeker dat u deze activiteit wilt annuleren?',

  // Booking
  DELIVERY_SERVICES: 'Bezorgdiensten',
  TAKE_AWAY: 'Ophalen',
  SPECIAL_REQUEST: 'Speciale Aanvraag',
  ORDER_CONFIRMATION: 'Order bevestiging',
  BOOKING_CREDIT:
    'Als u shoptegoed heeft wordt dit automatisch verrekend in de bestelling',
  BOOKING_COMPLETE: 'Afronden',
  BOOKING_OUR_SUGGESTIONS: 'Onze suggesties',
  BOOKING_CREATE_ACCOUNT:
    'Ik wil een account aanmaken voor toekomstige boekingen',
  AGREE_PRIVACY_STATEMENT_BOOK:
    'Door een account of bestelling aan te maken, gaat u akkoord met onze',

  // Event
  ADD_SPECIAL_REQUEST: 'Voeg speciaal verzoek toe',
  SEND_SPECIAL_REQUEST: 'Stuur een speciaal verzoek',

  USER_SUCCESS_UNSUBSCRIBED: 'U bent succesvol uitgeschreven',
  USER_FAILED_UNSUBSCRIBED:
    'Het is niet gelukt om u uit te schrijven, probeer het later nogmaals',
  USER_PROGRESS_UNSUBSCRIBED: 'Uitschrijven gebruiker',

  // Yet to be placed correctly
  LOG_IN: 'Log in',
  EMAIL_REQUIRED: 'E-mail is verplicht',
  EMAIL_VALID: 'E-mail moet een geldig e-mail zijn',
  EMAIL_NO_MATCH: 'De ingevoerde e-mail adressen komen niet overeen',
  PASSWORD_REQUIRED: 'Wachtwoord is verplicht',
  FIRST_NAME_REQUIRED: 'Voornaam is verplicht',
  LAST_NAME_REQUIRED: 'Achternaam is verplicht',
  PHONE_NR_REQUIRED: 'Telefoonummer is verplicht',
  STREET_REQUIRED: 'Straat is verplicht',
  HOUSE_NR_REQUIRED: 'Huisnummer is verplicht',
  POSTAL_CODE_REQUIRED: 'Postcode is verplicht',
  LOGIN_GOOGLE: 'Login met google',
  LOGIN_FACEBOOK: 'Login met facebook',
  LOGIN_APPLE: 'Login met apple',
  OR: 'Of',
  NO_SUCCESS_LOGGED_IN: 'Inloggen mislukt',
  LOGIN_ERROR:
    'Inloggen mislukt! Controleer of je alles correct hebt ingevoerd.',
  SUCCESS_LOGGED_IN: 'Succesvol ingelogd',
  SUCCESS_LOGGED_OUT: 'Succesvol uitgelogd',
  LOADING_ACTIVITIES_FAILED:
    'Er is iets mis gegaan met het ophalen van jouw activiteiten, probeer het later nogmaals',
  BOOK_ORDER_FAILED:
    'Er is iets mis gegaan met het boeken van jouw bestelling, probeer het later nogmaals',
  NO_DELIVERY_FOR_POSTAL_CODE:
    'Geen bezorging mogelijk op de geselecteerde postcode',
  FAILED_RESERVING_TICKETS:
    'Er is iets misgegaan met het reserveren van jouw ticket(s), probeer het later nogmaals',
  ONE_MOMENT: 'Even geduld...',
  WAITING_PAYMENT_PROCESS: 'Uw betaling wordt nu behandeld',
  PAYMENT_RECEIVED: 'Betaling ontvangen',
  PAYMENT_RECEIVED_DESC:
    'Uw betaling is ontvangen. U kunt uw geplande activiteiten bekijken door op de knop hieronder te klikken',
  PAYMENT_FAILED_DESC:
    'De transactie is mislukt en uw betaling is niet ontvangen. Controleer uw mail voor verdere instructies',
  PRODUCT_OVERWRITED_ITEM_IN_SHOPPING_CART:
    'Het product is met succes over jouw winkelwagen-item geschreven',
  ADD_SPECIAL_REQUEST_HERE: 'Voeg hier uw speciale verzoek toe',
  SPECIAL_REQUEST_SEND:
    'Uw speciale verzoek is verzonden naar de betreffende partner',
  FAILED_ADDING_SPECIAL_REQUEST:
    'Het is niet gelukt om uw speciale verzoek toe te voegen aan uw reserveringen, probeer het later nogmaals',
  FAILED_BOOKING_SPECIAL_REQUEST:
    'Het is niet gelukt om uw speciale verzoek te boeken, probeer het later nogmaals',
  THE_EVENT: 'Het event ',
  THE_PRODUCT: 'Het product ',
  THE_CATEGORY: 'De categorie ',
  ADDED_TO_FAV: ' is toegevoegd aan uw favorieten',
  ADDED_TO_FAV_GENERIC: 'Succesvol toegevoegd aan je favorieten',
  DELETED_FROM_FAV: ' is verwijderd uit uw favorieten',
  DELETED_FROM_FAV_GENERIC: 'Succesvol verwijderd uit je favorieten',
  SHOW_VIDEO: 'Toon video',
  SHOW_URL: 'Toon url',
  UNIT_PRICE: 'Eenheid prijs',
  UPLOAD_AN_IMAGE: 'Upload een afbeelding',
  FILE_NOT_BIGGER_THAN_10MB: 'bestandsgrootte kan niet groter dan 10MB zijn',
  FILE_NOT_AVAILABLE: 'Bestand is niet beschikbaar',
  BANNER_NOT_LOADED: 'De banner is niet correct geladen',
  NO_LOCATIONS_LOADED: 'Geen locaties geladen',
  ACCOUNT_SETTINGS: 'Account instellingen',
  INTERESTS: 'Interesses',
  FAVOURITES: 'Favorieten',
  NOTIFICATIONS: 'Notificaties',
  FIRST_NAME: 'Voornaam',
  LAST_NAME: 'Achternaam',
  HOUSE_NR: 'Huisnummer',
  PICK_AN_AVATAR: 'Kies een avatar',
  DIRECT_DEBIT_TITLE: 'Meer comfort met bestellingen ?',
  DIRECT_DEBIT_DESC_1: 'Bestel je regelmatig?',
  DIRECT_DEBIT_DESC_2:
    'Maak het uzelf gemakkelijk en betaal met automatische incasso. U kunt snel en zonder gedoe bestellen. Je vindt, je selecteert en je bent klaar.',
  DIRECT_DEBIT_DESC_3: 'Wilt u ook betalen met automatische incasso?',
  DIRECT_DEBIT_DESC_4: 'Start nu!',
  DIRECT_DEBIT_DESC_LIST_1: '1. Vul uw gegevens in en bevestig.',
  DIRECT_DEBIT_DESC_LIST_2: '2. Voer een eerste betaling uit met ideal.',
  DIRECT_DEBIT_DESC_LIST_3:
    '3. Binnen twee werkdagen is de automatische incasso geactiveerd.',
  I_WANT_TO_USE_DIRECT_DEBIT:
    'Ja, ik wil gebruik maken van automatische incasso',
  ACTIVATE_DIRECT_DEBIT: 'Automatische incasso activeren',
  DEACTIVATE_DIRECT_DEBIT: 'Automatische incasso deactiveren',
  DEACTIVATE_DIRECT_DEBIT_MSG:
    'Als automatische incasso is gedeactiveerd, heeft u meer stappen nodig om uw bestellingen af te ronden. U kunt de automatische incasso alsnog weer activeren als u meer gemak wilt bij het bestellen. Wilt u doorgaan met deactiveren?',
  DIRECT_DEBIT_ACTIVATED: 'Automatische incasso geactiveerd',
  DIRECT_DEBIT_NOT_ACTIVATED: 'Automatische incasso niet geactiveerd',
  DEACTIVATE_DIRECT_DEBIT_GENERIC_ERROR:
    'Kan automatische incasso niet deactiveren. Probeer het later opnieuw.',
  DEACTIVATE_DIRECT_DEBIT_SUBSCRIPTION_ERROR:
    'Kan automatische incasso niet deactiveren vanwege actieve abonnementen hieronder. Stop eerst met het volgen van abonnementen en probeer het dan opnieuw.',
  ACTIVATE_DIRECT_DEBIT_ERROR:
    'Activeren van automatische incasso mislukt. Probeer het later opnieuw.',
  DIRECT_DEBIT_PAYMENT_SUCCESS_DESC:
    'Uw betaling om automatische incasso te activeren is ontvangen. Geniet van uw bestelling met een veiligere en gemakkelijkere ervaring.',
  DIRECT_DEBIT_PAYMENT_FAILED_DESC:
    'De transactie is mislukt en automatische incasso is niet geactiveerd. Probeer het later opnieuw.',
  ACCOUNT_HOLDER_NAME: 'Rekeninghouder naam',
  SUCCESS_SAVING_SETTINGS: 'Uw instellingen zijn opgeslagen',
  FAILED_SAVING_SETTINGS:
    'Het is niet gelukt om uw instellingen op te slaan, probeer het later nogmaals',
  AVATAR_SIZE_MAX_2MB: 'Avatar bestandsgrootte mag niet meer dan 2 MB zijn',
  FAILED_SAVING_FAVOURITES:
    'Het is niet gelukt om uw favorieten op te slaan, probeer het later nogmaals',
  FAILED_GET_INTERESTS:
    'Het is niet gelukt om uw interesses op te halen, probeer het later nogmaals',
  FAILED_SAVING_INTERESTS:
    'Het is niet gelukt om uw interesses op te slaan, probeer het later nogmaals',
  AGREE_NOTIFICATIONS:
    'door de checkbox te selecteren, gaat u akkoord met het ontvangen van notificaties',
  FAILED_GET_NOTIFICATIONS:
    'Het is niet gelukt om uw notificatie instellingen op te halen, probeer het later nogmaals',
  SUCCESS_SAVE_NOTIFICATIONS: 'Uw notificatie instellingen zijn opgeslagen',
  FAILED_SAVE_NOTIFICATIONS:
    'Het is niet gelukt om uw notificatie instellingen op te slaan, probeer het later nogmaals',
  STAT_VIEWS: 'Keer bekeken',
  TRENDING_PRODUCTS: 'Trending producten',
  TRENDING_EVENTS: 'Trending activiteiten',
  TRENDING: 'Dit zijn onze toppers',
  TRENDING_NO_ITEMS: 'Geen trending items',
  GO_TO_ACCOUNT_SETTINGS: 'Ga naar Instellingen',

  // Subscriptions
  SUBSCRIPTION_TEXT:
    'Hoe wilt u op de hoogte gehouden worden voor nieuwe (recepten):',
  SUBSCRIPTION_EMAILS: 'Emails',
  SUBSCRIPTION_PUSH: 'Push berichten',
  CANCEL: 'Annuleren',

  NO_REVIEWS_AVAILABLE: 'Er zijn nog geen reviews beschikbaar',
  PICKUP_POINT: 'Afhaalpunt',
  NO_NAME_AVAILABLE: 'Geen naam beschikbaar',
  NO_ADDRESS_AVAILABLE: 'Geen adres beschikbaar',
  NO_PHONE_NUMBER_AVAILABLE: 'Geen nummer beschikbaar',
  NO_OPENING_HOURS_AVAILABLE: 'Geen openingstijden beschikbaar',

  VIEW: 'Bekijken',
  MAINTENANCE_1:
    'Kan niet verbinden met de server. Mogelijke reden is geen of een trage internetverbinding of onderhoudswerkzaamheden aan het platform.',
  MAINTENANCE_2: 'We proberen automatisch opnieuw verbinding te maken...',
  MAINTENANCE_3: 'In ',
  MAINTENANCE_4: ' seconden',
  SOMETHING_WENT_WRONG: 'Er is iets misgegaan',
  ITEMS_ADDED_TO_BASKET: 'Item(s) zijn toegevoegd aan uw winkelmand',
  ITEMS_ADDED_TO_BASKET_FOR_SHOPPINGLIST: 'Item(s) zijn toegevoegd aan',
  ITEMS_CHANGED_TO_BASKET_FOR_SHOPPINGLIST: 'Item(s) zijn gewijzigd in',
  GO_TO_SHOPPING_CART: 'Ga naar winkelmand',
  GO_TO_SHOPPING_LIST: 'Ga naar winkel lijst',
  CONTINUE_SHOPPING: 'Verder winkelen',
  EMPTY_CART: 'Leeg winkelwagen',

  // Chats
  SELECT_PARTNER_TO_CHAT: 'Selecteer een partner om een chat mee te starten',
  YOUR_CHAT_WITH: 'Jouw chat met ',
  NEW_SUBJECT: 'Nieuw onderwerp: ',
  TYPE_MESSAGE_HERE: 'Typ jouw bericht hier...',
  MESSAGE_NOT_SEND: 'Bericht is niet verzonden',
  PARTNER_SELECT: 'Selecteer een partner',

  // promotions
  PROMOTIONS_STAY_INFORMED: 'Blijf op de hoogte',
  PROMOTIONS_INFORMATION:
    'Tik op het hartje om op de hoogte te blijven van leuke acties zoals dit.',

  // newsletter
  NEWSLETTER: 'Nieuwsbrief',
  NEWSLETTER_TITLE: 'Als eerste op de hoogte?',
  NEWSLETTER_DESCRIPTION:
    'Blijf op de hoogte en ontvang leuke acties en scherpe aanbiedingen als eerste in uw mailbox',
  NEWS_LETTER_BUTTON: 'Houd me op de hoogte',

  NO_ACTIVITIES: 'Geen activiteiten beschikbaar',

  // auction
  AUCTION_EXPLANATION:
    "Bieden werkt als volgt: <br> - Ga naar het veilings evenement\n <br> - Kies een product om op te bieden <br> - Het bedrag loopt af, dus wacht tot het bedrag staat op uw gewenste bedrag\n <br> - Selecteer uw gewenste aantal en druk op 'mijn' <br> - Het product is nu van u voor de prijs waar het op eindigde",
  SHOPPING_CART_NAME: 'Winkelwagen',
  SHOPPING_LIST_NAME: 'Naam van de bestellijst',
  PICK_A_LIST: 'Kies een lijst',
  NEW_SHOPPING_LIST: '+ nieuwe bestellijst',
  TO_CONTINUE_PROVIDE_NAME: 'geef uw bestellijst een naam om verder te gaan',
  NO_SHOPLIST_YET:
    'Je hebt nog geen bestellijst, maak hieronder een bestellijst aan',
  SHOPPINGLISTS: 'Bestellijsten',
  SHOPPINGLISTS_PRODUCTS: 'Bestellijst producten',
  SHOPPINGLISTS_DETAILS: 'Bestellijst gegevens',
  NO_PRODUCTS_FOR_SHOPPINGLIST:
    'Er zijn nog geen producten voor de gekozen bestellijst',
  COPY_TO_SHOPPINGCART: 'kopieer naar winkelwagen',
  ADD_USER_TO_SHOPPINGLIST: 'Voeg nieuwe gebruiker toe',
  ADD_USER: 'Voeg toe',
  ENTER_MAIL: 'Vul het mailadres in',
  CHANGE_SHOPPINGLIST_NAME: 'Bestellijst naam wijzigen',
  DELETE_SHOPPINGLIST: 'Verwijder de bestellijst',
  SURE_DELETE_SHOPPINGLIST:
    'Weet u zeker dat u de volgende bestellijst wilt verwijderen: ',
  CANCEL_SHOPPINGLIST: 'Annuleer de bestelling',
  SURE_CANCEL_SHOPPINGLIST: 'Weet u zeker dat u de bestelling wilt annuleren?',
  DELETE_USER_FROM_MAIL_LIST: 'Verwijder de gebruiker van de mail lijst',
  SURE_DELETE_USER_FROM_MAIL_LIST:
    'Weet u zeker dat u de volgende gebruiker wilt verwijderen van de mail lijst: ',
  NEW_SHOPPING_LIST_TITLE: 'Nieuwe bestellijst',
  SAVE_SHOPPING_LIST_ERROR:
    'Kan de bestellijst niet opslaan. Probeer het later opnieuw.',

  NEWSLETTER_ALERT_SUCCESS:
    'Bedankt voor het aanmelden, je ontvangt nu leuke acties en scherpe aanbiedingen in jouw mail',
  NEWSLETTER_ALERT_USEREXISTED:
    'Het is niet gelukt om je aan te melden, het opgegeven email adres ontvangt al de leukste acties en scherpste aanbiedingen',
  NEWSLETTER_ALERT_ERROR: 'Er is iets mis gegaan, probeer het later nogmaals',
  STATUS: 'Status',
  PAY: 'Betalen',
  SEARCH_ORDERS: 'Zoek bestellingen...',
  DELIVERY_INFORMATION: 'Bezorgingsinformatie',
  DELIVERY_COST: 'bezorgkosten',
  GIVE_SHOPPING_LIST_NAME: 'Geef uw bestellijst een naam',
  CLEAR_SHOP_LIST: 'Bestellijst leegmaken',
  SURE_CLEAR_SHOP_LIST:
    'Weet u zeker dat u de producten van de volgende bestellijst wilt leegmaken: ',
  CLEAR: 'Leegmaken',
  LEAVE: 'Verlaat',
  DUTCHSTAMPS: 'Zegels',
  SAVING_DUTCH_STAMPS: 'Spaarzegels',
  STORE_CREDIT: 'Winkeltegoed',
  YOUR_STORE_CREDIT: 'Uw winkeltegoed voor ',
  CONTAINS: 'bedraagt: ',
  CURRENT_STAMP_AMOUNT: 'Huidig aantal zegels: ',
  CURRENT_FILLED_STAMP_BOOKS: 'Volle boekjes gespaard: ',
  TOTAL_STAMP_AMOUNT: 'Totaal aantal zegels: ',
  REDEEM_EXPL:
    'Als u uw volle boekjes wilt omzetten in winkeltegoed, druk dan op de onderstaande knop',
  REDEEM: 'Zet om',
  SKIP_DELIVERY: 'Volgende levering overslaan',
  SKIP_DELIVERY_CONFIRM_TITLE: 'Volgende levering overslaan',
  SKIP_DELIVERY_CONFIRM_MESSAGE:
    'Weet je zeker dat je de volgende levering overslaat? Als dat het geval is, zal het systeem de bezorging automatisch opnieuw voor u plannen op basis van uw herhalingsoptie.',
  SKIP_DELIVERY_SUCCESS:
    'De volgende levering is overgeslagen en er staat een nieuwe gepland.',
  SKIP_DELIVERY_ERROR:
    'Kan de volgende levering niet overslaan. Probeer het later opnieuw.',
  PAY_SHOPPING_LIST_TITLE: 'Bestellijst betalen',
  PAY_SHOPPING_LIST_MESSAGE: 'Weet u zeker dat door wilt gaan met de betaling?',

  EMPTY_SHOPPINGLIST: 'Leeg bestellijst',
  PICK_YOUR_MOMENT: 'Kies levermoment',
  PAY_NOW: 'Bestel',
  SHOPPING_LIST_DETAILS: 'Bestellijst details',
  ORDER_ONCE: 'U heeft geselecteerd dat de order eenmaal wordt uitgevoerd',
  ORDER_EVERY_WEEK:
    'Je hebt gekozen dat de bestelling elke week wordt herhaald',
  ORDER_EVERY_TWO_WEEKS:
    'Je hebt gekozen dat de bestelling elke twee weken wordt herhaald',
  ORDER_EVERY_THREE_WEEKS:
    'Je hebt gekozen dat de bestelling elke drie weken wordt herhaald',
  ORDER_EVERY_FOUR_WEEKS:
    'Je hebt gekozen dat de bestelling elke maand wordt herhaald',
  SHOPPING_LIST_DEADLINE: 'Deadline om wijzigingen aan te brengen',
  DELIVERY_SERVICE: 'Bezorginformatie',
  CLEAR_SHOPPING_LIST_MOMENT: 'Ik wil ook mijn levermoment verwijderen',
  SUCCESS_SELECTED_SHOPPING_LIST_MOMENT:
    'U heeft succesvol een levermoment gekozen voor de bestellijst',
  SUCCESS_SELECTED_SHOPPING_LIST_MOMENT_EXTRA:
    'De lijst wordt automatisch besteld als u toestemming heeft om op rekening of via automatische incasso te bestellen. Betaal anders de bestelling handmatig vóór de deadline. U ontvangt automatisch een email met een betaallink.',
  MOMENT_FOR_SHOPPINGLIST: 'Levermoment voor bestellijst',
  PICK_YOUR_DATE_AND_TIME: 'Kies uw datum / tijd',
  AUTOMATICALLY_REPEAT_ORDER: 'Wilt u de order automatisch herhalen?',
  REPEATING: 'Herhaling',
  CLEAR_SHOPPING_LIST_AFTER_PAYMENT: 'Leeg de bestellijst na betaling',
  CONFIRM_PICKUP_DELIVERY_MOMENT: 'Bevestig levermoment',
  ONCE: 'Eenmaal',
  EVERY_WEEK: 'Iedere week',
  EVERY_TWO_WEEKS: 'Elke twee weken',
  EVERY_THREE_WEEKS: 'Elke drie weken',
  EVERY_FOUR_WEEKS: 'Elke maand',
  EMAIL_NO_MATCH: 'Email komt niet overeen',
  PAYMENT_SHOPPINGLIST: 'Betaling bestellijst',
  PAYMENT_SHOPPINGLIST_SURE:
    'weet u zeker dat u door wilt gaan naar de betaling van de bestellijst?',
  GO_TO_ACCOUNT: 'Ga naar account',
  REVIEW_ONLY_WITH_NAME:
    'Het is alleen mogelijk om je mening achter te laten als je je naam hebt ingevuld in je accountgegevens. Om een ​​review achter te laten, dient u uw naam in uw account in te stellen.',
  CLICK_TO_SET_NAME:
    'Klik op de onderstaande knop om naar uw account te gaan om daar uw gegevens in te vullen.',
  // header texts
  HOMEPAGE: 'Homepagina',
  CATEGORIES: 'Categorieën',
  ORDER: 'Bestellen',
  KLANTENSERVICE: 'Service',
  REWARD_CLUB: 'Reward Club',
  CATEGORIES_TITLE: 'Blader door onze producten',

  // customer service
  WHAT_HELP_WITH: 'Waar kunnen we u mee helpen?',
  MY_ACCOUNT: 'Mijn account',
  MY_ORDERS: 'Mijn orders',
  BUG_REPORT: 'Bug report',
  M_A_Q: 'Meest gestelde vragen',
  SHOW_MORE: 'Toon meer',
  SHOW_LESS: 'Toon minder',
  REPORT_A_BUG: 'Report bugs aan de BuyFresh Helpdesk',
  GO_TO_ACCOUNT: 'Ga naar uw account instellingen',
  GO_ORDER: 'Ga naar uw orders',
  OTHER_QUESTIONS:
    'Heeft u nog andere vragen? Neem dan gerust contact met ons op',
  VOORDELEN_ONLINE: 'Waarom online bestellen in plaats van in de winkel?',
  VOORDELEN_ONLINE_DESC:
    'Online bestellen is makkelijk, veilig en bespaart tijd. U bestelt thuis op uw gemak in onze gebruiksvriendelijke webshop of app en betaalt contactloos en veilig online. Uw bestelling wordt thuisbezorgd of staat voor u klaar bij het pick-up point in de winkel. U vermijd drukte en hoeft niet in de rij te staan. Bovendien weet u zeker dat de gewenste producten beschikbaar zijn voor u. Uiteraard zijn uw (betaal)gegevens goed beveiligd tegen kwaadwillenden.',
  WHY_ACCOUNT: 'Waarom is het een goed idee om een account aan te maken?',
  WHY_ACCOUNT_DESC:
    'Met een account geniet u van extra gemak en leuke voordelen. Herhaal eenvoudig eerdere bestellingen, of maak gebruik van onze online bestellijst waaraan u in de loop van de week makkelijk benodigde producten toevoegt, die u vervolgens met één druk op de knop bestelt. Het is mogelijk te kiezen voor betaling met automatische incasso, zodat u niet telkens het betaalproces hoeft te herhalen. U profiteert daarnaast van leuke spaaracties, exclusieve activiteiten en kortingen.',
  QUESTIONS_ORDERS: 'Waar kan ik terecht met vragen over mijn bestelling?',
  QUESTIONS_ORDERS_DESC:
    'Voor vragen over of problemen met  uw bestelling kunt u contact opnemen met partnernaam. Dat kan via <a href="mailto:partnermail">partneremail</a> of <a href="tel:partnernum">partnernumb</a> tijdens openingstijden van onze winkel. ',
  QUESTIONS_ORDERS_DESC_2:
    'Voor vragen over of problemen met  uw bestelling kunt u contact opnemen met partnernaam. Dat kan via <a href="mailto:partnermail">partneremail</a> tijdens openingstijden van onze winkel. ',
  QUESTIONS_PRODUCTS: 'Wat als ik een wens of vraag over een product heb?',
  QUESTIONS_PRODUCTS_DESC:
    'Voor vragen over het assortiment, producten of speciale wensen en verzoeken kunt u contact opnemen met partnernaam. Dat kan via <a href="mailto:partnermail">partneremail</a> of <a href="tel:partnernum">partnernumb</a> tijdens openingstijden van onze winkel. ',
  QUESTIONS_PRODUCTS_DESC_2:
    'Voor vragen over het assortiment, producten of speciale wensen en verzoeken kunt u contact opnemen met partnernaam. Dat kan via <a href="mailto:partnermail">partneremail</a> tijdens openingstijden van onze winkel. ',
  WORKING_SHOPCREDITS: 'Hoe werkt online winkeltegoed?',
  WORKING_SHOPCREDITS_DESC:
    'Online winkeltegoed is alleen beschikbaar voor klanten met een account. Als u nieuw online winkeltegoed heeft ontvangt u hierover bericht. Online winkeltegoed wordt automatisch verrekend met uw eerstvolgende online bestelling. U moet ingelogd zijn om gebruik te kunnen maken van het online winkeltegoed. Pas in de laatste stap in het bestelproces bij de betaling wordt het winkeltegoed van het bestelbedrag afgetrokken. Daar ziet u dat het bedrag van uw bestelling verlaagd is. Neem bij vragen of problemen contact op met de helpdesk van Buy Fresh<a href="mailto:helpdesk@buyfresh.nl">helpdesk@buyfresh.nl</a> of <a href="tel:0297382468">0297 382468</a>',
  PROBLEMS_WEBSHOP: 'Wat als ik een problemen met de webshop of app heb?',
  PROBLEMS_WEBSHOP_DESC:
    'Ervaart u een probleem met de webshop of app? Dat vinden wij heel vervelend, onze excuses! We helpen u graag zo snel mogelijk weer op weg. Neem daarom bij problemen of technische vragen contact op net de helpdesk van Buy Fresh via <a href="mailto:helpdesk@buyfresh.nl">helpdesk@buyfresh.nl</a> of <a href="tel:0297382468">0297 382468</a> ',
  WHAT_BUYFRESH: 'Wat is Buy Fresh?',
  WHAT_BUYFRESH_DESC:
    'Buy Fresh is een online platform voor het bestellen van ambachtelijke producten direct bij lokale telers, boeren, slagers, bakkers en poeliers. Buy Fresh is de ideale combinatie van online en een fysieke winkel. Buy Fresh maakt het gemakkelijk om voor de kwaliteit van de lokale versspecialist te kiezen. Door te kopen via Buy Fresh steunt u lokale winkels en kiest u in veel gevallen voor duurzamere producten uit de regio. Kijk voor meer informatie op <a href="https://www.buyfresh.nl">www.buyfresh.nl</a>.',
  OPEN: 'Geopend',
  MAIL_WITH_US: 'Mail met ons',
  CALL_US: 'Bel ons',
  TECHINCAL_HELP:
    'Voor hulp bij technische problemen neem contact op met de <a href="mailto:helpdesk@buyfresh.nl">Buyfresh</a> helpdesk',
  DIRECTLY_TO: 'Direct naar',
  TECH_SUPPORT_TEXT:
    'Vervelend dat u een probleem ervaart. Laat ons weten wat er aan de hand is, dan helpen we u zo snel mogelijk. Meld u een nog onbekende technische bug, dan krijgt u 5 euro gratis online winkeltegoed ',

  // bug report
  WHEN_OCCURANCE: 'Wanneer deed het probleem zich voor? ',
  DESCRIPTION_PROBLEM: 'Beschrijving van het probleem',
  WHAT_PLATFORM:
    'Waar deed het probleem zich voor? Website, mobiele website, Android of Apple app? ',
  TECHINCAL_SUPPORT: 'Technische ondersteuning',

  // logout
  ARE_YOU_SURE_LOGOUT: 'Weet u zeker dat u uit wilt loggen?',

  ONLY_FOR_MEMBERS: 'Dit product is alleen voor gebruikers beschikbaar',

  YOUR_DUTCH_STAMPS: 'Uw gespaarde zegels',
  CREATE_ACCOUNT_FOR_STAMPS:
    'Maak nu een account aan om voor zegels te sparen en veel meer voordelen.',
  YOUR_FAVOURITES: 'Jouw favorieten!',
  YOU_HAVE: 'U heeft',
  FULL_CARDS: 'volledige kaarten',
  STAMPS_YOUR_PARTNER_STAMPS: 'Uw (partner) zegels',
  OPEN_STAMPS: 'Open mijn zegels',

  // rental changes
  RENTAL_DIALOG_TITLE: 'Voeg meer items toe?',
  RENTAL_DIALOG_DESC:
    'Wilt u meer items van deze categorie <b>%s</b> aan uw bestelling toevoegen?',
  NO_STARTDATES:
    'Er zijn helaas geen data waarop deze producten beschikbaar zijn',

  // Search
  SEARCH_SENTENCE: 'Waar ben je naar op zoek?',

  // open url
  GO_TO: 'Ga naar',

  RESULTS: 'resultaten',
  ALERT_NO_DATES:
    'Er zijn momenteel geen data waarop uw bestelling kan worden bezorgd of opgehaald',

  // blog posts
  BLOG_POSTS: 'Beleef',
  BLOGS: 'Recente artikelen',
  BLOGS_TITLE: 'Kijk eens naar onze blogs',

  COPY_TO_CLIPBOARD_SUCCEEDED: 'Succesvol gekopieerd naar klembord',
  COPY_TO_CLIPBOARD_FAILED: 'Kopiëren naar klembord is mislukt',
  AGENDA: 'Agenda',
  AGENDA_NO_EVENTS: 'Geen aankomende evenementen',

  // app promotion
  DOWNLOAD_APP: 'Ontdek het gemak van onze app',
  APP_TEXT:
    'Bestel makkelijk, veilig en snel met de PARTNERNAAM app.  Download nu voor Android of Apple.',

  // delete account
  ERROR_DELETE_USER:
    'Er is een fout opgetreden bij het verwijderen van de gebruiker, probeer het later opnieuw',
  SUCCESS_DELETE_ACC: 'Account succesvol verwijderd',
  DELETE_ACCOUNT: 'Verwijder account',
  DELETE_ACCOUNT_ARE_YOU_SURE:
    'Als u uw account verwijderd kunt u uw order niet meer zien. Weet u zeker dat u uw account wilt verwijderen? Deze actie kan niet teruggedraaid worden.',

  DAYS: 'dagen',
  CHARACTERISTICS: 'Kenmerken',

  DELIVERY_ADDRESS: 'Bezorgadres',
  NO_CONFIDENCE_ADDRESS:
    'We konden uw adres niet vinden met de postcode en het huisnummer dat u hebt opgegeven, vul het alstublieft zelf in',
  ENTER_EMAIL_TEXT:
    'Voer uw e-mailadres in om in te loggen, een account aan te maken of op de hoogte te blijven van uw bestelling',

  // order overview
  ORDER_OV_PRICE: 'Prijs',
  CONTACT_DETAILS: 'Contactgegevens',

  CONTINUE_AS_GUEST: 'Doorgaan als gast',
  DELIVERY_DETAILS: 'Verzendgegevens',
  DELIVERY_DATE: 'Bezorgdatum en tijd',
  PHONE_NO_RECOGNITION: 'Incorrect telefoonnummer',
  PHONE_NO_RECOGNITION_DESC:
    'We herkennen dit telefoonnummers formaat niet. Weet u zeker dat deze correct is?',
  PHONE_WHY:
    'Wij vragen voor uw telefoonnummer zodat als er iets mis gaat met uw order kunnen wij u telefonisch informeren',
  RESERVE_ORDER: 'Bestelling reserveren',
  ENTER_EMAIL: 'Voer uw email in',
  RETURNING_CUSTOMER: 'Terugkomende klant',
  NEW_CUSTOMER: 'Nieuwe klant',
  CREATE_ACCOUNT: 'Account aanmaken',
  RENTAL_DETAILS: 'Huurgegevens',
  CHECKOUT: 'Kassa',
  ENTER_YOUR_EMAIL: 'Voer uw email in',
  EMAIL_WHY:
    'Voer je e-mailadres in om in te loggen, een account aan te maken of verder te gaan als gast',
  LOGIN_INFO:
    'We hebben een account gevonden met het ingevulde e-mailadres, wil je inloggen?',
  WHY_LOGIN: 'Door in te loggen kunt u uw user credits gebruiken en nog meer',
  FOUND_AN_ACCOUNT:
    'Wij hebben een account gevonden met uw ingevoerde e mailadres wilt u inloggen?',
  BENEFITS_REGISTERING:
    'Wanneer u een account registreert, krijgt u toegang tot deze voordelen en nog veel meer!',
  LOGIN_OR_CONTINUE: 'Login of doorgaan als gast',
  CREATE_ACCOUNT_OR_CONTINUE: 'Maak een account of doorgaan als gast',
  SUCCESS_REGISTER:
    'Je hebt je succesvol geregistreerd, je hebt een bevestigingsmail ontvangen, bevestig je account a.u.b.',
  ORDER_ACCOUNT_NOT_ACTIVATED:
    'Account aangemaakt maar nog niet geactiveerd. Ga naar je mailbox om je account te activeren voordat je kunt inloggen en verder kunt gaan.',

  // Subscription
  SUBSCRIBE: 'Abonneren',
  SUBSCRIPTION: 'Abonnement',
  CREATE_SUBSCRIPTION: 'Abonnement aanmaken',
  TAKE_SUBSCRIPTION: 'Sluit abonnement af',
  TAKE_SUBSCRIPTION_HTML: 'Sluit flex<br>abonnement af',
  ITEMS_NOT_SELECTED: 'Items niet geselecteerd',
  ITEMS_SELECTED: 'Items geselecteerd',
  ADD_ALL: 'Voeg alle',
  REMOVE_ALL: 'Verwijder alles',
  REMOVE: 'Verwijderen',
  CANCEL_ORDER: 'Annuleren',
  ADD_SUBSCRIPTION_PRODUCTS_TITLE: 'Kies uit de lijst',
  NO_START_DATES: 'Startdata zijn niet beschikbaar voor uw selectie',
  NO_START_TIMES: 'Starttijden zijn niet beschikbaar voor uw selectie',
  SUBSCRIPTION_REPETITION_TITLE:
    'Met welke frequentie wil je je abonnement herhalen?',
  SUBSCRIPTION_REPETITION_FREQUENCY: 'Herhaalfrequentie van je abonnement',
  SUBSCRIPTION_OVERVIEW: 'Overzicht abonnement',
  SUBSCRIPTION_NAME: 'Abonnementsnaam',
  SUBSCRIPTION_NAME_TOOLTIP:
    'U kunt uw gewenste abonnementsnaam invoeren om de standaardnaam te vervangen',
  SUBSCRIPTION_PRODUCTS: 'Abonnement producten',
  PICKUP_DATE_TIME: 'Tijdstip',
  CREATE_SUBSCRIPTION_DESC_DIRECT_DEBIT_ON:
    'Je hebt automatische incasso geactiveerd. Jouw betaling wordt automatisch afgehandeld via automatische incasso.',
  CREATE_SUBSCRIPTION_DESC_DIRECT_DEBIT_OFF:
    'Automatische incasso is vereist om een abonnement aan te maken. Door je abonnement op te slaan, betaal je <b>1 cent</b> om eerst automatische incasso te activeren. Jouw abonnement wordt aangemaakt wanneer de betaling succesvol is ontvangen.',
  CREATE_SUBSCRIPTION_ACTIVATE_DIRECT_DEBIT_TITLE:
    'Activeer automatische incasso om het abonnement te voltooien',
  CREATE_SUBSCRIPTION_ACTIVATE_DIRECT_DEBIT_DESC:
    'U wordt doorgestuurd naar de betaalpagina om <b>1 cent</b> te betalen, die wordt toegevoegd aan uw tegoeden, om automatische incasso te activeren. Het doel van de betaling is om ons uw bankrekeninggegevens te verstrekken voor automatische afschrijving van uw abonnement. Uw abonnement wordt aangemaakt wanneer de betaling succesvol is ontvangen.',
  CREATE_SUBSCRIPTION_SUCCESS_TITLE: 'Abonnement aangemaakt',
  CREATE_SUBSCRIPTION_SUCCESS: 'Het abonnement is aangemaakt.',
  CREATE_SUBSCRIPTION_ERROR:
    'Kan abonnement niet maken. Probeer het later opnieuw.',
  SUBSCRIPTION_PAYMENT_SUCCESS_MSG:
    'De betaling is ontvangen om automatische incasso te activeren en uw abonnement is succesvol aangemaakt. Je kunt het abonnement bekijken op de pagina met uw bestellijsten.',
  SUBSCRIPTION_PAYMENT_ERROR_MSG:
    'De transactie is mislukt. Automatische incasso is niet geactiveerd en uw abonnement is niet aangemaakt. Probeer eerst automatische incasso te activeren op de pagina Accountinstellingen en maak vervolgens uw abonnement opnieuw aan. Neem contact met ons op als het probleem aanhoudt.',
  CREATE_SUBSCRIPTION_EXPLAN:
    'Met de volgende stappen kun je een nieuw abonnement aanmaken waarmee je jouw gewenste producten periodiek kunt laten bezorgen of afhalen.',
  SUBSCRIPTION_TO_DELIVERY_EXPLAN:
    'In de volgende stap kun je de bezorg- of afhaalmethode selecteren en de datum/tijd waarop deze herhaling begint.',
  SUBSCRIPTION_STEP1: 'Stap 1: Kies jouw producten',
  SUBSCRIPTION_STEP2: 'Stap 2: Abonnementstype',
  SUBSCRIPTION_STEP3: 'Stap 3: Leveringsopties',
  SUBSCRIPTION_STEP4: 'Stap 4: Samenvatting',
  INVALID_POSTAL_CODE: 'Ongeldige postcode',
  MIN_SUBSCRIPTION_VALUE:
    'De minimale totale waarde van uw geselecteerde producten om een abonnement aan te maken is',
  MIN_SUBSCRIPTION_VALUE_ALERT:
    'Je moet meer producten aan de lijst toevoegen. De minimale totale waarde van uw geselecteerde producten is',
  SHOPPING_LISTS_AND_SUBSCRIPTIONS: 'Abonnementen en bestellijsten',
  GO_TO_SUBSCRIPTION: 'Ga naar abonnement',
  SUBSCRIPTION_LOGIN_ALERT:
    'Log in of maak een account aan voordat je een abonnement kunt aanmaken',
  SUBSCRIPTION_BENEFITS_TITLE: 'Abonnementskenmerken',
  ADD_PRODUCT: 'Product toevoegen',
  REMOVE_ALL_PRODUCTS: 'Alle producten verwijderen',
  DELETE_SUBSCRIPTION_TITLE: 'Abonnement verwijderen',
  DELETE_SUBSCRIPTION_DESC:
    'Weet je zeker dat je dit abonnement wilt verwijderen?',
  LOGIN_REQUIRED: 'Inloggen vereist',
  SUBSCRIPTION_INTRODUCTION_TITLE: 'Abonnementsservice',
  SUBSCRIPTION_INTRODUCTION_DESC:
    'Vergeet je weleens tijdig te bestellen of heb je gewoon geen zin om telkens een nieuwe bestellijst te maken? Wij bieden de mogelijkheid om een lijst met producten samen te stellen die je periodiek kunt laten bezorgen. Deze kun je laten bezorgen of zelf komen afhalen op een van de locaties. Vlak voordat je lijst wordt ingepakt, krijg je nog de mogelijkheid om de lijst aan te passen. Als je niets doet dan wordt de bestelling automatisch geplaatst. Een keertje overslaan als je op vakantie bent kan natuurlijk ook.<br><br>Het leuke is ook dat je deze lijst kunt delen met je huisgenoten, zodat iedereen die je uitnodigt producten op de lijst kan plaatsen.<br><br>Alle voordelen op een rijtje:',
  LIMITED_PRODUCT_LEFT: 'Slechts %d items over voor uw selectie',
  SUBSCRIPTION_REPEATING_PRODUCTS: 'Herhalende producten',
  SUBSCRIPTION_ONETIME_PRODUCTS: 'Eenmalige producten',
  SUBSCRIPTION_QUANTITY: 'Abonnementshoeveelheid',
  ADD_TO_SUBSCRIPTION: 'Toevoegen aan abonnement',
  REMOVE_ITEM_ERROR:
    'Kan het item niet verwijderen. Probeer het later opnieuw.',
  UPCOMING_ORDER: 'Aankomende bestelling',
  UPDATE_SUBSCRIPTION: 'Opslaan als standaard',
  UPDATE_SUBSCRIPTION_DIALOG_MSG:
    'Wil je je lijst updaten met de aanstaande bestelling?',
  UPDATE_SUBSCRIPTION_SUCCESS: 'Bestellijst is succesvol bijgewerkt',
  UPDATE_SUBSCRIPTION_ERROR:
    'Kan je lijst niet updaten. Probeer het later opnieuw.',
  RESET_SUBSCRIPTION: 'Standaardlijst herstellen',
  RESET_SUBSCRIPTION_DIALOG_MSG:
    'Wilt u uw bestellijst herstellen naar de standaardlijst?',
  RESET_SUBSCRIPTION_SUCCESS: 'Bestellijst is succesvol hersteld',
  RESET_SUBSCRIPTION_ERROR:
    'Kan uw bestellijst niet herstellen. Probeer het later opnieuw.',
  ITEM_CHANGE_SAVED: 'Artikelwijziging is opgeslagen',
  ITEM_REMOVED: 'Artikel is verwijderd',

  INTERNATIONAL_DELIVERY_DATE_ALERT:
    'Dit is uw voorkeurstijdvak voor internationale bezorging, dit kan afwijken van de werkelijke bezorgtijd. Controleer uw e-mail om de leveringsupdates van het koeriersbedrijf te ontvangen.',

  COOKIE_TEXT:
    'Deze website maakt gebruik van cookies zodat u de beste ervaring op onze website krijgt.',

  PRODUCT_PERSONAL_DISCOUNT_TITLE: 'Uw persoonlijke korting',
  PRODUCT_PERSONAL_DISCOUNT_DESC:
    'Voeg dit product zo snel mogelijk toe aan je winkelmandje om een persoonlijke korting te krijgen',

  PROF_USER_CHECKBOX_LABEL: 'Ik ben een zakelijke klant',
  KVK_NUMBER: 'KvK number',
  VAT_NUMBER: 'BTW nummer',
  VAT: 'BTW',
  TOTAL_PRICE_EXCL_VAT: 'Totale prijs excl. BTW',

  SUBSCRIPTION_BUY_BY_ACCOUNT_REMINDER_MSG:
    'Er zijn twee betaalmogelijkheden om te kopen met een abonnementenlijst: Kopen op Rekening of Automatische incasso. De eerste optie is niet beschikbaar voor u op dit account. Als u Kopen op Rekening wilt gebruiken, neem dan contact op met uw leverancier. Anders gaat u verder en wordt u later gevraagd om automatische incasso in te schakelen.',

  DELIVERY_OPTIONS: 'Bezorgopties',
  SERVER_MAINTENANCE_TITLE: 'Server onderhoud',
  SERVER_MAINTENANCE_MESSAGE:
    'Onze server is tijdelijk niet beschikbaar wegens onderhoud. Kom later terug om het opnieuw te proberen.',
  POOR_BANDWIDTH_TITLE: 'Trage internetverbinding',
  POOR_BANDWIDTH_MESSAGE: 'Controleer uw internetinstellingen.',
  MAKE_CHOICE_FOR_DELIVERY_PICKUP: 'Maak een keuze',

  QUIZ_INTRO_TEXT:
    "Beantwoord de onderstaande vragen en druk op de knop 'Verzenden' als je klaar bent.",
  QUIZ_SEND_SUCCESS_TEXT: 'Jouw antwoorden zijn succesvol verzonden.',
  QUIZ_SEND_FAILED_TEXT:
    'Het is niet gelukt de antwoorden te versturen. Probeer het later opnieuw.',
  QUIZ_MUST_CHOOSE_MULTI: 'Je moet een van de opties kiezen.',
  QUIZ_MUST_FILL_IN: 'Je moet een antwoord invullen.',
  QUIZ_MUST_CHOOSE_PHOTO: 'Je moet een foto selecteren.',
  QUIZ_MUST_CHOOSE_VIDEO: 'Je moet een video selecteren.',
  QUIZ_MUST_GIVE_NAME: 'We hebben jou voornaam nodig voor communicatie.',
  QUIZ_TEXT_LABEL: 'Vul hier het antwoord in.',
  QUIZ_NUMBER_LABEL: 'Vul hier een nummer in.',
  QUIZ_EMAIL_DESC:
    'We hebben je e-mailadres en voornaam nodig om je te informeren over de uitslag en voor communicatie.',
  QUIZ_QUESTION_NOT_ANSW:
    'Uw antwoorden kunnen niet worden verzonden. Niet alle vragen zijn ingevuld.',

  PRODUCT_OPTIONS_TITLE: 'Opties',
  PRODUCT_OPTIONS_DESCR1: 'Selecteer minimaal ',
  PRODUCT_OPTIONS_DESCR2: ' opties en maximaal ',
  PRODUCT_OPTIONS_DESCR3: ' optie(s) te weinig gekozen',
  PRODUCT_OPTIONS_DESCR4: ' optie(s) te veel gekozen',
  PRODUCT_OPTIONS_DESCR5: 'Selecteer ',
  PRODUCT_OPTIONS_DESCR6: ' optie(s)',
  PRODUCT_OPTIONS_ERROR: 'Het aantal gekozen productopties is niet juist.',

  DEF_CHANGE_INVALID_QTY_TITLE: 'Hoeveelheidswijziging vereist',
  DEF_CHANGE_NO_CAPACITY_MSG:
    'Dit artikel is niet op voorraad, kies een ander artikel.',
  LEAVE_SHARED_LIST_MSG:
    'U gaat de huidige lijst verlaten. Na links zie je deze lijst niet meer. Weet je zeker dat je weggaat?',
  DEF_CHANGE_QTY_LESS_THAN_CAPACITY_MSG:
    'Er zijn nog maar %d items over. Wilt u het aantal naar deze waarde verlagen?',

  SHOPPING_CART_LOWERCASE: 'winkelwagen',
  SHOPPING_LIST_LOWERCASE: 'bestellijst',
  E_PCAP_001_ADD_PROD:
    'Kan het product niet toevoegen aan uw %s, omdat de hoeveelheid het maximum overschrijdt. Verlaag het aantal en probeer het opnieuw.',
  E_PCAP_001_CHANGE_PROD:
    'Kan het product in uw %s niet wijzigen, omdat de hoeveelheid het maximum overschrijdt. Verlaag het aantal en probeer het opnieuw.',
  E_PCAP_002_ADD_PROD:
    'Kan het product niet toevoegen aan uw %s, omdat de hoeveelheid kleiner is dan het minimum. Verhoog het aantal en probeer het opnieuw.',
  E_PCAP_002_CHANGE_PROD:
    'Kan het product in uw %s niet wijzigen, omdat de hoeveelheid kleiner is dan het minimum. Verhoog het aantal en probeer het opnieuw.',

  LEAVE_SHARED_LIST_TITLE: 'Verlaat de lijst',

  PAYMENT_METHOD_AUTOMATIC: 'Online betalen',
  PAYMENT_METHOD_AUTOMATIC_INFO:
    'Betaal de bestelling met iDEAL/Creditcard, gebruikerstegoeden, automatische incasso of kopen op rekening, afhankelijk van uw accountinstellingen.',
  PAYMENT_METHOD_ON_DELIVERY: 'Bij levering',
  PAYMENT_METHOD_ON_DELIVERY_INFO:
    'Betaal de bestelling bij aflevering of afhalen, afhankelijk van de verzendmethode.',
  PAYMENT_METHOD_IDEAL_INFO_DIRECT:
    'Betaal de bestelling met iDeal. Je wordt naar de Mollie internet betaalpagina doorgestuurd.',
  PAYMENT_METHOD_IDEAL_INFO_DELAYED:
    'Betaal de bestelling met iDeal. Je ontvangt een email met een betaallink.',
  PAYMENT_METHOD_DIRECT_DEBIT_INFO:
    'Betaal de bestelling met automatische incasso. Het bedrag wordt automatisch van je rekening afgeschreven.',
  PAYMENT_METHOD_AT_EVENT_INFO:
    'Betaal de bestelling bij het afhalen/levering.',
  PAYMENT_METHOD_CREDIT_CARD_INFO_DIRECT:
    'Betaal de bestelling met jou credit card. Je wordt naar de Mollie internet betaalpagina doorgestuurd.',
  PAYMENT_METHOD_CREDIT_CARD_INFO_DELAYED:
    'Betaal de bestelling met jou credit card. Je ontvangt een email met een betaallink.',
  PAYMENT_METHOD_ON_ACCOUNT_INFO:
    'Betaal de bestelling op rekening. U krijgt een factuur toegestuurd.',
  SELECT_PAYMENT_METHOD: 'Kies betalingsmethode',
  SELECTED_PAYMENT_METHOD: 'Geselecteerde betalingsmethode',
  SELECTED_PAYMENT_METHOD_INFO_LIST:
    "Als je de betalingsmethode wilt wijzigen, druk op de 'Annuleren' knop om het automatisch herhalend bestellen te stoppen. Daarna kun je met de knop 'Kies levermoment' ook de betalingsmethode opnieuw kiezen.",
  SELECTED_PAYMENT_METHOD_INFO_SUBSC:
    "Als je de betalingsmethode wilt wijzigen, druk op de 'Verwijderen' knop om het abonnement te verwijderen. Daarna kun je het abonnement opnieuw aanmaken en de gewenste betaalmethode kiezen.",
  SELECT_PAYMENT_METHOD_NO_SELECT_ERROR:
    'Betaalmethode is vereist. Kies er een uit de lijst.',
  HOSTNET_ISSUE_ALERT_TITLE: 'Email probleem',
  HOSTNET_ISSUE_ALERT:
    'Helaas heeft onze emailprovider Hostnet momenteel problemen met het verwerken van emails. Als gevolg daarvan kan het zijn dat emails ter bevestiging van een bestelling niet direct aankomen. Zijn werken hard aan een oplossing. Zodra alles weer operationeel is zullen wij proberen e.e.a. alsnog te verzenden. Excuses voor het ongemak.\nTeam Buy Fresh',
  MINIMUM_ORDER_VALUE_TEMP: 'Minimale bestelwaarde %s',
  PICKUP_MINIMUM_ORDER_VALUE_ALERT:
    'Minimale bestelwaarde van %s niet bereikt voor geselecteerde afhaaloptie.',
  PICKUP_FEE_INFO: 'Ophaalkosten: %s',
  PICKUP_FEE: 'Ophaalkosten',
  PICKUP_NOT_POSSIBLE: 'Voor uw keuze is afhalen niet mogelijk.',
  PICKUP_FREE_ORDER_VALUE: 'Gratis voor bestellingen boven €%s',
  GET_PAYMENT_METHODS_ERROR:
    'Kan betalingsmethoden niet ophalen. Probeer het later opnieuw.',
  PREVIOUS_BUTTON_PROMOTION: 'Vorige promotie',
  NEXT_BUTTON_PROMOTION: 'Volgende promotie',
  PREVIOUS_BUTTON_BLOG: 'Vorig artikel',
  NEXT_BUTTON_BLOG: 'Volgend artikel',
  TERMS_AND_CONDITIONS: 'Algemene voorwaarden',
  POWERED_BY: 'Mogelijk gemaakt door',
};

export { NL as default };
